/* jshint esversion: 6 */
import React from 'react';
import AIHelper from 'app/components/PostingTool/Accessories/AIHelper.jsx';
import BlueskyCreds from 'app/components/SocialModal/BlueskyCreds.jsx';
import CategoryChooser from 'app/components/PostingTool/Accessories/CategoryChooser.jsx';
import CategoryProvider from 'app/redux/Providers/CategoryProvider.jsx';
import ComboButton from 'app/components/common/ComboButton.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { compose } from 'redux';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import SocialRestoreModule from 'app/modules/SocialRestoreModule.jsx';
import { SOCIAL_CREATE, SOCIAL_UPDATE } from 'app/redux/constants.js';
import CreateFeedOutputPanel from 'app/components/EditorComponents/CreateFeedOutputPanel.jsx';
import EverqueueControls from 'app/components/PostingTool/Accessories/EverqueueControls.jsx';
import EverqueueProvider from 'app/redux/Providers/EverqueueProvider.jsx';
import FirstSuccessModal from 'app/components/Modals/FirstSuccessModal.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import GalleryChooser from 'app/components/PostingTool/Accessories/GalleryChooser.jsx';
import HashtagGenerator from 'app/components/PostingTool/Accessories/HashtagGenerator.jsx';
import ImageEditorModal from 'app/components/PostingTool/Accessories/ImageEditorModal.jsx';
import LabelLibrary from 'app/components/PostingTool/LabelLibrary.js';
import LinkPreview from 'app/components/PostingTool/LinkPreview.jsx';
import Loading from 'app/components/common/Loading.jsx';
import MastodonHandle from 'app/components/SocialModal/MastodonHandle.jsx';
import MediaSourceMenu from 'app/components/PostingTool/MediaSourceMenu.jsx';
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';
import MinimalModal from 'app/components/Modals/MinimalModal.jsx';
import Picker from 'emoji-picker-react';
import PostingGroups from 'app/components/PostingTool/Accessories/PostingGroups.jsx';
import PostProvider from 'app/redux/Providers/PostProvider.jsx';
import PostScheduler from 'app/components/PostingTool/Accessories/PostScheduler.jsx';
import PostSocialButton from 'app/components/PostingTool/PostSocialButton.jsx';
import PostToolUploader from 'app/components/PostingTool/PostToolUploader.jsx';
import QueueProvider from 'app/redux/Providers/QueueProvider.jsx';
import ServiceFields from 'app/components/PostingTool/ServiceFields.jsx';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import TextareaEvents from 'app/components/PostingTool/TextareaEvents.js';
import ThumbnailPreview from 'app/components/PostingTool/ThumbnailPreview.jsx';
import TypeSelection from 'app/components/SocialModal/TypeSelection.jsx';
import UploadcareModal from 'app/components/uploadcare/UploadcareModal.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import Utilities from 'app/utility/Utilities.js';
import UtilityProvider from 'app/redux/Providers/UtilityProvider.jsx';
import VideoEditor from 'app/components/PostingTool/Accessories/VideoEditor.jsx';
import MediaEditor from 'app/components/MediaEditor/MediaEditor.jsx';
import * as _ from 'underscore';
import makeToast from 'app/modules/makeToast.js';

const urlRegex = /(\b(((https?|ftp|file|):\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

const postDataDefault = {
    shared: {
        message: '',
        mb_id: 0, // used for editing
        hashes: [], // used for new posts
        imageType: null,
        link: '',
        imageLink: ''
    },
    services: {},
    params: {
        postFlag: 0,
        post_times: []
    },
    otherData: {}
};

const convertObjectToDate = (date, isTime, tz) => {
    let nextDate = null;

    if (_.isObject(date)) {
        nextDate = new moment().tz(tz);
        if (isTime) {
            if (_.isNumber(date.minutes) && date.minutes >= 0) {
                nextDate.minutes(date.minutes);
            }
            if (_.isNumber(date.hours) && date.hours >= 0) {
                nextDate.hours(date.hours);
            }
        } else {
            nextDate.month((date.month - 1));
            nextDate.date(date.day);
            nextDate.year(date.year);
        }
    }

    return nextDate;
};

const convertDateToObject = (date, isTime) => {
    let dateObj = null;

    if (date && moment.isMoment(date)) {
        dateObj = {};
        if (isTime) {
            dateObj.minutes = date.minutes();
            dateObj.hours = date.hours();
        } else {
            dateObj.month = date.month() + 1;
            dateObj.day = date.date();
            dateObj.year = date.year();
        }
    }

    return dateObj;
};

const gatherFields = (source, validator, rqType) => {
    let fields = [],
        formKeys = Object.keys(validator.forms);

    source.map((key) => {
        if (formKeys.indexOf(key) !== -1) {
            if (validator.forms[key] !== undefined && validator.forms[key].requires[rqType]) {
                fields = fields.concat(validator.forms[key].requires[rqType]);
            }
        } else {
            fields.push(key);
        }
    });

    return fields;
};

const getFormFields = (form) => {
    let fields = [];

    if (form.optional !== undefined) {
        fields = fields.concat(form.optional);
    }

    if (form.requires.all !== undefined) {
        fields = fields.concat(form.requires.all);
    }

    if (form.requires.any !== undefined) {
        fields = fields.concat(form.requires.any);
    }

    return fields;
};

class PostingTool extends React.Component {
    constructor(props) {
        super(props);

        let formDefaults = {},
            constants = props.app.config.constants,
            linklessServices = [],
            populateTitleForServices = [];

        formDefaults[constants.POST_SVC_TWITTER] = 'status';
        formDefaults[constants.POST_SVC_FACEBOOK] = 'status_update';
        formDefaults[constants.POST_SVC_TUMBLR] = 'blog_post';
        formDefaults[constants.POST_SVC_LINKEDIN] = 'post';
        formDefaults[constants.POST_SVC_PINTEREST] = 'pin';
        formDefaults[constants.POST_SVC_FEED] = 'feed_post';
        formDefaults[constants.POST_SVC_INSTAGRAM_BUSINESS] = 'media_post';
        formDefaults[constants.POST_SVC_GMYBUSINESS] = 'STANDARD';
        formDefaults[constants.POST_SVC_STOCKTWITS] = 'status';
        formDefaults[constants.POST_SVC_SLACK] = 'post';
        formDefaults[constants.POST_SVC_DISCORD] = 'post';
        formDefaults[constants.POST_SVC_BLOGGER] = 'blog_post';
        formDefaults[constants.POST_SVC_WORDPRESS] = 'blog_post';
        formDefaults[constants.POST_SVC_REDDIT] = 'text_post';
        formDefaults[constants.POST_SVC_MASTODON] = 'status_update';
        formDefaults[constants.POST_SVC_TIKTOK] = 'video_post';
        formDefaults[constants.POST_SVC_BLUESKY] = 'status';
        formDefaults[constants.POST_SVC_NEXTDOOR] = 'POST';
        formDefaults[constants.POST_SVC_YOUTUBE] = 'media_post';
        formDefaults[constants.POST_SVC_THREADS] = 'status';
        formDefaults[constants.POST_SVC_SNAPCHAT] = 'story';

        linklessServices = [
            constants.POST_SVC_TWITTER,
            constants.POST_SVC_INSTAGRAM_BUSINESS,
            constants.POST_SVC_GMYBUSINESS,
            constants.POST_SVC_BLOGGER,
            constants.POST_SVC_PINTEREST,
            constants.POST_SVC_WORDPRESS,
            constants.POST_SVC_STOCKTWITS,
            constants.POST_SVC_SLACK,
            constants.POST_SVC_REDDIT,
            constants.POST_SVC_TUMBLR,
            constants.POST_SVC_TIKTOK,
            constants.POST_SVC_BLUESKY,
            constants.POST_SVC_THREADS,
            constants.POST_SVC_SNAPCHAT
        ];

        populateTitleForServices = [
            constants.POST_SVC_SLACK,
            constants.POST_SVC_REDDIT,
            constants.POST_SVC_TUMBLR,
            constants.POST_SVC_BLOGGER,
            constants.POST_SVC_PINTEREST,
            constants.POST_SVC_FEED,
            constants.POST_SVC_DISCORD,
            constants.POST_SVC_WORDPRESS
        ];

        this.formDefaults = formDefaults;
        this.linklessServices = linklessServices;
        this.populateTitleForServices = populateTitleForServices;

        this.state = {
            userPrefs: {
                showLabels: false
            },
            showSortMenu: false,
            selectedSocials: {},
            saveState: false,
            accessoryModalStack: [],
            accessoryServiceId: 0,
            accessoryHash: '',
            aiMode: '',
            isEmojiPickerVisible: false,
            isSocialWarningVisible: false,
            editMode: 'shared',
            linkPreviews: {},
            linksWithErrors: [],
            mediaThumbs: [],
            videoInfo: [],
            postData: Utilities.deepClone(postDataDefault),
            apiErrors: {},
            validationErrors: {},
            mediaErrors: {},
            postErrors: [],
            postAction: 'share',
            isWorking: false,
            isDirty: false,
            isLoading: true,
            isLinkLoading: false,
            socialHelperView: '',
            whichEscapeHatch: '',
            isHashtagSelectorVisible: false,
            postSource: '',
            returnUrl: '',
            reconnectingSocialId: 0,
            addBatchSocials: false,
            preBatchSocials: []
        };


        // textbox refs
        this.sharedMessageRef = React.createRef();
        this.emojiPickerRef = React.createRef();

        // menu refs
        this.sortMenuRef = React.createRef();
        this.comboRef = React.createRef();

        // link fetch related things
        this.keyUpTimeout = 0;
        this.keyUpPasteFlag = false;

        this.getSelectedSocialCount = this.getSelectedSocialCount.bind(this);
        this.onSocialClick = this.onSocialClick.bind(this);
        this.addSelectedSocial = this.addSelectedSocial.bind(this);
        this.showSortMenu = this.showSortMenu.bind(this);
        this.sortMenuHandler = this.sortMenuHandler.bind(this);
        this.selectAllHandler = this.selectAllHandler.bind(this);
        this.toggleEmojiPicker = this.toggleEmojiPicker.bind(this);
        this.addEmoji = this.addEmoji.bind(this);
        this.showCategoryPicker = this.showCategoryPicker.bind(this);
        this.addCategory = this.addCategory.bind(this);
        this.interactionCheck = this.interactionCheck.bind(this);
        this.attachMedia = this.attachMedia.bind(this);
        this.changeEditMode = this.changeEditMode.bind(this);
        this.getCharCount = this.getCharCount.bind(this);
        this.getUrlPreview = this.getUrlPreview.bind(this);
        this.removeLink = this.removeLink.bind(this);
        this.postActionHandler = this.postActionHandler.bind(this);
        this.makePost = this.makePost.bind(this);
        this.inferFormType = this.inferFormType.bind(this);
        this.validateServices = this.validateServices.bind(this);
        this.updateMediaErrors = this.updateMediaErrors.bind(this);
        this.clearMediaErrors = this.clearMediaErrors.bind(this);
        this.initService = this.initService.bind(this);
        this.checkForImportData = this.checkForImportData.bind(this);
        this.importItem = this.importItem.bind(this);
        this.addLinkInfoToPostData = this.addLinkInfoToPostData.bind(this);
        this.switchView = this.switchView.bind(this);
        this.removeThumb = this.removeThumb.bind(this);
        this.transformGoogleData = this.transformGoogleData.bind(this);
        this.addItemInfoDecorator = this.addItemInfoDecorator.bind(this);
        this.showMediaEditor = this.showMediaEditor.bind(this);
        this.supportsMediaEditing = this.supportsMediaEditing.bind(this);
        this.pushAccessoryModal = this.pushAccessoryModal.bind(this);
        this.popAccessoryModal = this.popAccessoryModal.bind(this);
        this.mediaHashHasErrors = this.mediaHashHasErrors.bind(this);
        this.toggleHashtagSelector = this.toggleHashtagSelector.bind(this);
        this.hashtagSelectionCallback = this.hashtagSelectionCallback.bind(this);
        this.showAIHelper = this.showAIHelper.bind(this);
        this.getMediaCount = this.getMediaCount.bind(this);
        this.setTikTokForm = this.setTikTokForm.bind(this);
        this.storeVideoInfo = this.storeVideoInfo.bind(this);
        this.removeVideoInfo = this.removeVideoInfo.bind(this);
        this.hasVideoThumbSupport = this.hasVideoThumbSupport.bind(this);
        this.sortSocialsByAvailability = this.sortSocialsByAvailability.bind(this);
        this.onSocialCreated = this.onSocialCreated.bind(this);
        this.onSocialUpdated = this.onSocialUpdated.bind(this);

        // Held rather than rebuilt: unregistering matches the object that registered.
        this.socialCallbacks = [
            {action: SOCIAL_CREATE, func: this.onSocialCreated},
            {action: SOCIAL_UPDATE, func: this.onSocialUpdated}
        ];

    }

    static getDerivedStateFromProps(props, state) {
		let socialModalUp = state.socialModalUp;

		if (props.isDuplicateSocialModalVisible || props.isBlacklistModalVisible || props.isClientSocialModalVisible || props.isUpgradeModalVisible) {
			socialModalUp = true;
		} else {
			socialModalUp = false;
		}

		return (socialModalUp !== state.socialModalUp) ? { socialModalUp } : null;

	}

    componentDidMount() {
        if (!this.props.app.firstLoad.SOCIAL_LIST) {
            this.props.getSocials();
        } else {
            this.sortSocialsByAvailability();
            this.setState({
                isLoading: false
            }, () => {
                if (this.props.app.firstLoad.SOCIAL_LIST === true && this.props.app.firstLoad.POST_VALIDATORS_LIST === true) {
                    this.checkForImportData();
                }
            });

            if (this.props.router.query !== null && this.props.router.query.id !== undefined) {
                let social = this.props.socials.list.find(({id}) => { return id === parseInt(this.props.router.query.id); });
                if (social && social.activeFlag) {
                    this.addSelectedSocial(parseInt(this.props.router.query.id));
                }
            }
        }

        // get the types for TypeSelection for the empty/no active socials state
        this.props.getSocialTypes();

        let priorState = this.props.getPersistedData('postingState');
        if (priorState) {
            this.setState(priorState);
            this.props.clearPersistedData('postingState');
        }

        let prefs = this.props.getPersistedData('postingPrefs');
        if (prefs) {
            this.setState({
                userPrefs: prefs
            });
        }

        this.props.remoteReturnHandler([{
			method: 'POST',
			path: '/content/post',
			callback: null
		}]);

        this.props.remoteReturnHandler([{
			method: 'REAUTH',
			path: '/content/post',
			callback: null
		}]);

        document.addEventListener('mouseup', this.interactionCheck);
        document.addEventListener('touchend', this.interactionCheck);

        this.socialCallbacks.map((callback) => { this.props.registerCallback(callback); });

        if (this.props.router.query !== null && this.props.router.query.helper !== undefined) {
            let cleanUrl = window.location.href.substring(0, window.location.href.indexOf("?"));
            if (this.props.router.query.helper === 'link') {
                this.showAIHelper('guidedlink');
            } else {
                this.showAIHelper('guided');
            }
        	window.history.replaceState({}, '', cleanUrl);

        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.router.query !== null && this.props.router.query.new !== undefined) {
            this.setState({
                selectedSocials: {},
                postData: Utilities.deepClone(postDataDefault),
                editMode: 'shared',
                postAction: 'share',
                whichEscapeHatch: '',
                postSource: '',
                returnUrl: ''
            }, () => {
                this.sortSocialsByAvailability();
                this.props.router.navigate("/content/post");
            });
            return;
        }

        const clearSocialErrors = () => {
            this.props.deleteApiError(['SOCIAL_CREATE']);
        };

        const extractErrors = (errors) => {
            let nextApiErrors = Utilities.deepClone(this.state.apiErrors),
                nextPostErrors = [...this.state.postErrors],
                nextEditMode = this.state.editMode,
                errorMsg = '';

            const addPostError = (error) => {
                if (nextPostErrors.indexOf(error) === -1) {
                    nextPostErrors.push(error);
                }
            };

            errors.map((error) => {
                if (error.errors !== undefined) {
                    if (error.errors.validation !== undefined && error.errors.validation.content !== undefined) {
                        Object.keys(error.errors.validation.content).map((serviceId) => {
                            nextApiErrors[serviceId] = error.errors.validation.content[serviceId];
                        });
                        nextEditMode = 'network';
                    } else {
                        if (error.errors.perms !== undefined) {
                            addPostError(error.errors.perms.msg);
                        } else if (error.errors.validation !== undefined) {
                            if (error.errors.validation.msg !== undefined) {
                                addPostError(error.errors.validation.msg);
                            }
                            if (error.errors.validation.accounts !== undefined) {
                                if (_.isString(error.errors.validation.accounts)) {
                                    addPostError(error.errors.validation.accounts);
                                } else {
                                    Object.keys(error.errors.validation.accounts).map((paID) => {
                                        let social = this.props.socials.list.find(({id}) => { return id === parseInt(paID);});
                                        if (social) {
                                            addPostError(`${social.name} ${error.errors.validation.accounts[paID]}`);
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            });

            this.setState({
                apiErrors: nextApiErrors,
                postErrors: nextPostErrors,
                editMode: nextEditMode,
                isWorking: false
            });

        };

        // due to how upgrade modals can be shown by a lot of components which
        // may or may not have understanding that the social filter needs to be reset
        // be sure to set the filter when some modal(s) goes to no modals.
        if (prevProps.modals.stack.length > 0 && this.props.modals.stack.length === 0) {
            this.sortSocialsByAvailability();
        }

        if (this.props.isDuplicateSocial() && !this.props.isDuplicateSocialModalVisible) {
			let duplicateSocial = {};

			// the post for the last action is in the error. for the time being
			// just dig it out of the errors
			for (let i = 0; i < this.props.app.errors.api.length; ++i) {
				if (this.props.app.errors.api[i].type === 'SOCIAL_CREATE' || this.props.app.errors.api[i].type === 'SOCIAL_UPDATE') {
					duplicateSocial = this.props.app.errors.api[i].post;
				}
			}
			duplicateSocial.force = 1;
            duplicateSocial.activeFlag = 1;


			this.props.showDuplicateSocialModal(duplicateSocial, {
				confirm: clearSocialErrors,
				cancel: clearSocialErrors
			});

		} else if (this.props.isOverTheLimit() && !this.props.isUpgradeModalVisible) {
            let errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
			if (this.props.appName === "dlvr") {
				this.props.showUpgradeModal(() => {
					clearSocialErrors();
					this.props.closeAllModals();
				}, null, errors, 'post_tool');
			} else if (this.props.appName === "client") {
				this.props.showClientSocialModal({
					confirm: clearSocialErrors
				});
			}
		} else if (this.props.isBlacklisted() && !this.props.isBlacklistModalVisible) {
			this.props.showBlacklistModal({
				confirm: clearSocialErrors,
				cancel: clearSocialErrors
			});
		} else if (this.props.isMovementRestricted() && !this.props.isMovementRestrictedModalVisible) {
            this.props.showMovementRestrictedModal({
                confirm: clearSocialErrors,
                cancel: clearSocialErrors
            });
        }

        if (prevProps !== undefined && prevProps.app.firstLoad.SOCIAL_LIST === false && this.props.app.firstLoad.SOCIAL_LIST === true) {
            this.setState({
                isLoading: false
            });
        }

        if (Object.keys(prevProps.socials.batchCreates).length > 0 && Object.keys(this.props.socials.batchCreates).length === 0) {
			this.setState({
				addBatchSocials: true,
				preBatchSocials: [...this.props.socials.list]
			});
		}

        if (prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false) {
            this.sortSocialsByAvailability();
            if (this.props.router.query !== null && this.props.router.query.id !== undefined) {
                let social = this.props.socials.list.find(({id}) => { return id === parseInt(this.props.router.query.id)});
                if (social && social.activeFlag) {
                    this.addSelectedSocial(parseInt(this.props.router.query.id));
                }
            }


            if (this.state.addBatchSocials) {
                let nextSelectedSocials = Utilities.deepClone(this.state.selectedSocials);
                this.props.socials.list.map((social) => {
                    if (!this.state.preBatchSocials.find((priorSocial) => priorSocial.id === social.id)) {
                        if (nextSelectedSocials[social.psID] === undefined) {
                            nextSelectedSocials[social.psID] = [social.id];
                        } else {
                            nextSelectedSocials[social.psID].push(social.id);
                        }
                    }
                });

                this.setState({
                    preBatchSocials: [],
                    addBatchSocials: false,
                    selectedSocials: nextSelectedSocials
                });

            } else {
                this.checkForImportData();
            }

        }

        if (prevProps && prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false) {
            let errors = this.props.getApiErrors(['SUB_ADDON_UPDATE']);
            if (errors.length) {
                this.props.addMessage(UserMessages.generateFlashMessage("There was an error updating your plan, check the account page", "SUB_ADDON_UPDATE"));
            } else {
                this.props.getUserPerms();
                this.props.getUser();
                this.props.closeAllModals();
            }
        }

        /*
         * The second half of a click on an inactive account: onSocialClick asks
         * for fresh perms and parks the id, and the answer lands here. Perms are
         * refetched rather than read from the store because bringing an account
         * back consumes an output slot, and a count cached since page load is
         * routinely stale by the time someone reaches this list.
         */
        if (prevProps.app.loading.USER_FETCH_PERMS === true && this.props.app.loading.USER_FETCH_PERMS === false) {
            if (this.state.reconnectingSocialId) {
                let social = this.props.socials.list.find(({id}) => id === this.state.reconnectingSocialId);
                if (social) {
                    /*
                     * Same door as the connect dialog, and the same module
                     * behind it — including the plan check, which reads the
                     * perms that just arrived. This list takes the defaults: a
                     * ReactivateModal on the stack and a direct redirect, since
                     * there is no dialog here to put either inside.
                     */
                    if (parseInt(social.activeFlag, 10) === 0) {
                        this.props.restoreSocial(social);
                    } else {
                        this.addSelectedSocial(this.state.reconnectingSocialId);
                    }

                    this.setState({
                        reconnectingSocialId: 0
                    });
                }
            }
        }

        if (prevProps.app.firstLoad.POST_VALIDATORS_LIST === false && this.props.app.firstLoad.POST_VALIDATORS_LIST === true) {
            this.checkForImportData();
        }

        if (prevProps.app.loading.UTILITIES_URL_INFO_FETCH === true && this.props.app.loading.UTILITIES_URL_INFO_FETCH === false) {
            let errors = this.props.getApiErrors(['UTILITIES_URL_INFO_FETCH']),
                nextLinkPreviews = Utilities.deepClone(this.state.linkPreviews),
                nextPostErrors = Utilities.deepClone(this.state.postErrors),
                nextApiErrors = Utilities.deepClone(this.state.apiErrors),
                nextPostData = Utilities.deepClone(this.state.postData),
                nextLinksWithErrors = [...this.state.linksWithErrors];

            if (errors.length) {
                errors.map((error) => {
                    let url = (error.errors !== undefined && error.errors.request !== undefined) ? error.errors.request.url : '',
                        errorMsg = (error.errors !== undefined && error.errors.validation !== undefined) ? error.errors.validation.url : '';

                    if (this.state.editMode === 'shared') {
                        if (errorMsg && nextPostErrors.indexOf(errorMsg) === -1) {
                            nextPostErrors.push(errorMsg);
                        }
                    } else {
                        if (errorMsg) {
                            Object.keys(this.state.postData.services).map((serviceId) => {
                                let serviceData = this.state.postData.services[serviceId];
                                if (serviceData.link === url) {
                                    if (nextApiErrors[serviceId] === undefined) {
                                        nextApiErrors[serviceId] = {};
                                    }
                                    nextApiErrors[serviceId].link = errorMsg;
                                }
                            });
                        }
                    }

                    if (nextLinksWithErrors.indexOf(url) === -1) {
                        nextLinksWithErrors.push(url);
                    }

                    // clear out errored links
                    if (nextPostData.shared.link === url) {
                        nextPostData.shared.link = '';
                    }

                    if (Object.keys(nextPostData.services).length) {
                        Object.keys(nextPostData.services).map((serviceId) => {
                            if (nextPostData.services[serviceId].link === url) {
                                nextPostData.services[serviceId].link = '';
                            }
                        });
                    }

                    if (nextLinkPreviews[url] !== undefined) {
                        delete nextLinkPreviews[url];
                    }

                    this.props.deleteApiError(['UTILITIES_URL_INFO_FETCH']);

                });

                this.setState({
                    postData: nextPostData,
                    postErrors: nextPostErrors,
                    apiErrors: nextApiErrors,
                    linkPreviews: nextLinkPreviews,
                    linksWithErrors: nextLinksWithErrors,
                    isLoading: false,
                    isLinkLoading: false
                });
            } else {
                let nextLinkPreviews = Utilities.deepClone(this.state.linkPreviews),
                    nextPostData = Utilities.deepClone(this.state.postData);

                if (Object.keys(this.props.utilities.urlInfo).length) {
                    nextLinkPreviews[this.props.utilities.urlInfo.url] = Utilities.deepClone(this.props.utilities.urlInfo);
                    this.props.clearUrlInfo();
                    this.setState({
                        linkPreviews: nextLinkPreviews,
                        isLoading: false,
                        isLinkLoading: false
                    }, () => {
                        // Add the image link to services that need it
                        if (this.state.editMode === 'network') {
                            Object.keys(nextPostData.services).map((serviceId) => {
                                this.addLinkInfoToPostData(nextPostData, parseInt(serviceId));
                            });
                            this.setState({
                                postData: nextPostData
                            });
                        }
                    });

                }
            }
        }

        if (prevProps && !_.isEqual(prevProps.posts.mediaValidation, this.props.posts.mediaValidation)) {
            let previousKeys = Object.keys(prevProps.posts.mediaValidation),
                currentKeys = Object.keys(this.props.posts.mediaValidation);

            let removalKeys = _.difference(previousKeys, currentKeys);
            this.updateMediaErrors(this.props.posts.mediaValidation);
            if (removalKeys.length) {
                this.clearMediaErrors(removalKeys);
            }
        }

        this.validateServices(this.state.isDirty);

        if (prevProps.app.loading.POST_CREATE === true && this.props.app.loading.POST_CREATE === false) {
            let errors = this.props.getApiErrors(['POST_CREATE']);

            if (errors.length) {
                let nextApiErrors = Utilities.deepClone(this.state.apiErrors),
                    nextPostErrors = [...this.state.postErrors],
                    nextEditMode = this.state.editMode,
                    errorMsg = '';

                const addPostError = (error) => {
                    if (nextPostErrors.indexOf(error) === -1) {
                        nextPostErrors.push(error);
                    }
                };

                errors.map((error) => {
                    if (error.errors !== undefined) {
                        if (error.errors.validation !== undefined && error.errors.validation.content !== undefined) {
                            Object.keys(error.errors.validation.content).map((serviceId) => {
                                nextApiErrors[serviceId] = error.errors.validation.content[serviceId];
                            });
                            nextEditMode = 'network';
                        } else {
                            if (error.errors.perms !== undefined) {
                                addPostError(error.errors.perms.msg);
                            } else if (error.errors.validation !== undefined) {
                                if (error.errors.validation.msg !== undefined) {
                                    addPostError(error.errors.validation.msg);
                                }
                                if (error.errors.validation.accounts !== undefined) {
                                    if (_.isString(error.errors.validation.accounts)) {
                                        addPostError(error.errors.validation.accounts);
                                    } else {
                                        Object.keys(error.errors.validation.accounts).map((paID) => {
                                            let social = this.props.socials.list.find(({id}) => { return id === parseInt(paID);});
                                            if (social) {
                                                addPostError(`${social.name} ${error.errors.validation.accounts[paID]}`);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });

                this.setState({
                    apiErrors: nextApiErrors,
                    postErrors: nextPostErrors,
                    editMode: nextEditMode,
                    isWorking: false
                });

            } else {
                // POST SUCCESS!!! RESET AND GO AGAIN!
                // what's a post creation without a litle tracking
                let onboarding = null;
                if (typeof(Storage) !== undefined) {
                    onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
                }
                if (dataLayer && onboarding !== null) {
                    dataLayer.push({
                        event: 'first_post',
                        method: 'manual'
                    });
                }
                if (onboarding !== null) {
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Onboarding - Complete',
                            event_data: {
                                'method': 'Manual Post'
                            }
                        });
                    }
                    window.localStorage.removeItem('onboarding');
                    // show a special modal if this is their first rodeo with us
                    this.props.addModal(
                        <FirstSuccessModal
                            {...this.props}
                            context="firstpost"/>
                    );
                } else {
                    makeToast("Post created", "success");
                }
                if (this.state.whichEscapeHatch === "back") {
                    if (this.state.postSource === 'calendar' && this.state.returnUrl) {
                        let returnUrl = this.state.returnUrl.replace(this.props.app.config.appUrl, "");
                        this.props.router.navigate(
                            returnUrl);
                    } else {
                        this.props.router.navigate(-1);
                    }
                }

                this.setState({
                    isWorking: false,
                    isDirty: false,
                    selectedSocials: {},
                    linkPreviews: {},
                    mediaThumbs: [],
                    videoInfo: [],
                    postData: Utilities.deepClone(postDataDefault),
                    editMode: 'shared',
                    isHashtagSelectorVisible: false,
                    postSource: ''
                });
            }
        }

        if (prevProps.app.loading.QUEUE_UPDATE === true && this.props.app.loading.QUEUE_UPDATE === false ||
            prevProps.app.loading.EVERQUEUE_UPDATE === true && this.props.app.loading.EVERQUEUE_UPDATE === false) {
            let socialId = this.state.postData.otherData.socialId,
                url = (this.state.editMode === 'edit-queue') ? '/queue/detail' : '/queue/everqueue',
                action = (prevProps.app.loading.QUEUE_UPDATE === true && this.props.app.loading.QUEUE_UPDATE === false) ? 'QUEUE_UPDATE' : 'EVERQUEUE_UPDATE';

            let errors = this.props.getApiErrors(['QUEUE_UPDATE', 'EVERQUEUE_UPDATE']);

            if (errors.length) {
                let nextApiErrors = Utilities.deepClone(this.state.apiErrors),
                    nextPostErrors = [...this.state.postErrors],
                    errorMsg = '',
                    social = this.props.socials.list.find(({id}) => { return id === socialId;});

                const addPostError = (error) => {
                    if (nextPostErrors.indexOf(error) === -1) {
                        nextPostErrors.push(error);
                    }
                };

                errors.map((error) => {
                    if (error.errors !== undefined) {
                        if (error.errors.validation !== undefined && error.errors.validation.content !== undefined) {
                            Object.keys(error.errors.validation.content).map((field) => {
                                addPostError(error.errors.validation.content[field]);
                            });
                        } else if (error.errors.validation !== undefined && error.errors.validation.msg !== undefined) {
                            addPostError(error.errors.validation.msg);
                        }
                    }
                });

                this.setState({
                    postErrors: nextPostErrors,
                    isWorking: false
                });

            } else {
                makeToast("Post updated", "success");
                this.props.router.navigate(`${url}/${socialId}`);
            }

        }

        // check whether the network indicator shows or not
        // if the user hasn't touched anything, don't show it
        if (!this.state.isDirty && this.state.editMode === 'shared') {
            if (this.state.postData.shared.message !== '' || (
                this.state.postData.shared.hashes !== undefined && this.state.postData.shared.hashes.length)) {
                this.setState({
                    isDirty: true
                });
            }
        }

        // save state if the user doesn't have any socials the new onboarding sends them
        // straight into the ai tool so they could have text before a social
        if (this.state.isDirty && this.state.editMode === 'shared' && this.props.socials.list.length === 0) {
            this.props.persistData('postingState', this.state);
        }

    }

    componentWillUnmount() {

        if (this.state.saveState) {
            this.props.persistData('postingState', this.state);
        }

        this.props.clearFilter('socials');

        document.removeEventListener('mouseup', this.interactionCheck);
        document.removeEventListener('touchend', this.interactionCheck);

        this.socialCallbacks.map((callback) => { this.props.unregisterCallback(callback); });

    }

    /*
     * Accounts needing a reconnect sort last rather than being filtered out of
     * the list, so they can be clicked to fix. Every caller wants that same
     * order, which is why it is one method and not four copies of two
     * predicates.
     */
    sortSocialsByAvailability() {
        this.props.sortStore('socials', 'name', 'ASC', [
            (social) => { return social.activeFlag === 1 || (social.activeFlag === 0 && social.sysActionFlag === 0); },
            (social) => { return social.activeFlag === 0 && social.sysActionFlag === 1; }
        ]);
    }

    /*
     * A social was connected from the manual post tool, so select it — connecting one
     * here is only ever a step towards posting to it. The list is refetched
     * because the create response carries a thinner record than the list does.
     */
    onSocialCreated(detail) {
        let nextSelectedSocials = Utilities.deepClone(this.state.selectedSocials),
            constants = this.props.app.config.constants,
            social = detail.social;

        if (this.props.getApiErrors(['SOCIAL_CREATE']).length) {
            return;
        }

        if (social) {
            if (nextSelectedSocials[social.psID] === undefined) {
                nextSelectedSocials[social.psID] = [];
            }
            nextSelectedSocials[social.psID].push(social.id);
            this.setState({
                selectedSocials: nextSelectedSocials
            });

            if ([constants.POST_SVC_INSTAGRAM_BUSINESS, constants.POST_SVC_FACEBOOK, constants.POST_SVC_TIKTOK].indexOf(social.psID) !== -1) {
                this.props.getSocialInputCreds();
            }
        }

        this.props.getUserPerms();
        this.sortSocialsByAvailability();
        this.props.closeAllModals();
        this.props.getSocials(true);

    }

    /*
     * An account that was switched off and is now on is one the user just
     * brought back — from the list here or from the dialog over it — and
     * bringing it back is how you ask to post to it.
     *
     * The transition is what matters, not the new value: an ordinary edit of an
     * account that was already active must not select it. `detail.before` is the
     * other half of that comparison.
     */
    onSocialUpdated(detail) {
        detail.changed.map((social) => {
            let before = detail.before[social.id];

            if (!before || parseInt(before.activeFlag, 10) !== 0 || parseInt(social.activeFlag, 10) !== 1) {
                return;
            }

            if (this.state.selectedSocials[social.psID] === undefined ||
                this.state.selectedSocials[social.psID].indexOf(social.id) === -1) {
                this.addSelectedSocial(social.id);
            }
        });

    }

    initService(postData, serviceId) {
        let constants = this.props.app.config.constants;

        switch (parseInt(serviceId)) {
            case constants.POST_SVC_TWITTER:
                /*
                 * Seeded rather than left undefined: a manual post to X gets a QR code, on a
                 * dark card, unless someone says otherwise, and an absent value would read as
                 * off, and light, everywhere downstream.
                 */
                postData.services[serviceId].postQrCode = 1;
                postData.services[serviceId].postDarkQR = 1;
                break;

            case constants.POST_SVC_GMYBUSINESS:
                postData.services[serviceId].form = 'STANDARD';
                if (postData.services[serviceId].link !== '') {
                    postData.services[serviceId].cta_type = 'LEARN_MORE';
                } else {
                    postData.services[serviceId].cta_type = 'ACTION_TYPE_UNSPECIFIED';
                }
                break;

            case constants.POST_SVC_REDDIT:
                if (postData.services[serviceId].link !== '') {
                    postData.services[serviceId].form = 'link_post';
                } else if (postData.services[serviceId].hashes !== undefined && postData.services[serviceId].hashes.length > 0) {
                    postData.services[serviceId].form = 'image_post';
                } else {
                    postData.services[serviceId].form = 'text_post';
                }
                break;

            case constants.POST_SVC_TIKTOK:
                postData.services[serviceId].disable_music = true;
                postData.services[serviceId].disable_comment = false;
                postData.services[serviceId].disable_duet = false;
                postData.services[serviceId].disable_stitch = false;
                postData.services[serviceId].brand_content_toggle = false;
                postData.services[serviceId].brand_organic_toggle = false;
                if (this.getMediaCount("image") >= 1) {
                    postData.services[serviceId].form = 'photo_post';
                    postData.services[serviceId].message = postData.shared.message;
                } else {
                    postData.services[serviceId].form = 'video_post';
                    postData.services[serviceId].video_title = postData.shared.message;
                }
                break;

            case constants.POST_SVC_YOUTUBE:
                postData.services[serviceId].privacy_status = 'public';
                postData.services[serviceId].license = 'youtube';
                postData.services[serviceId].embeddable = true;
                postData.services[serviceId].made_for_kids = false;
                postData.services[serviceId].notify_subs = true;
                postData.services[serviceId].category = 0;
                postData.services[serviceId].tags = [];
                postData.services[serviceId].postAsShort = false;
                if (postData.shared.message) {
                    postData.services[serviceId].video_description = postData.shared.message;
                }

            case constants.POST_SVC_INSTAGRAM_BUSINESS:
                postData.services[serviceId].publishAsStory = false;
                break;

            case constants.POST_SVC_FACEBOOK:
                postData.services[serviceId].publishAsStory = false;
                postData.services[serviceId].publishAsReel = false;
                break;

            case constants.POST_SVC_SNAPCHAT:
                if (this.getMediaCount("image") >= 1 || postData.shared.message.trim() === '') {
                    postData.services[serviceId].form = "story";
                } else if (postData.shared.message.trim() !== '') {
                    postData.services[serviceId].form = "spotlight";
                }
                break;

            default:
                break;
        }


        return postData;
    }

    checkForImportData() {
        let isScheduled = false;

        let curationItem = this.props.getPersistedData('curationItem');
        if (curationItem) {
            this.importItem(curationItem, 'curation');
            this.props.clearPersistedData('curationItem');
            this.setState({
                editMode: 'shared',
                postAction: 'queue',
                whichEscapeHatch: 'back',
                postSource: 'curation'
            });
        }

        let queueItem = this.props.getPersistedData('queueItem');
        if (queueItem) {
            this.importItem(queueItem, 'queue');
            this.props.clearPersistedData('queueItem');
            isScheduled = (queueItem.preview.post_ts !== undefined) ? true : false;
            this.setState({
                editMode: 'edit-queue',
                postAction: (isScheduled) ? 'schedule' : 'save',
                whichEscapeHatch: 'cancel',
                postSource: 'queue'
            });
        }

        let everqueueItem = this.props.getPersistedData('everqueueItem');
        if (everqueueItem) {
            this.importItem(everqueueItem, 'queue');
            this.props.clearPersistedData('everqueueItem');
            this.setState({
                editMode: 'edit-everqueue',
                postAction: 'save',
                whichEscapeHatch: 'cancel',
                postSource: 'everqueue'
            });
        }

        let repostItem = this.props.getPersistedData('repostItem');
        if (repostItem) {
            this.importItem(repostItem, 'repost');
            this.props.clearPersistedData('repostItem');
            this.setState({
                editMode: 'shared',
                postAction: 'share',
                whichEscapeHatch: 'back'
            });
        }

        let scheduleDateData = this.props.getPersistedData('scheduleDate');
        if (scheduleDateData) {

            let nextPostData = Utilities.deepClone(this.state.postData);
            let { date, hasHour, source } = JSON.parse(scheduleDateData);
            this.props.clearPersistedData('scheduleDate');
            let scheduleDate = new moment(date).tz(this.props.user.detail.timezone);
            if (hasHour === false) {
                scheduleDate.hour(moment().hour());
                scheduleDate.minute(moment().minute());
            }
            nextPostData.params.post_times.push(scheduleDate.format("X"));
            this.setState({
                editMode: 'shared',
                postAction: 'schedule',
                whichEscapeHatch: 'back',
                postData: nextPostData,
                postSource: 'calendar',
                returnUrl: decodeURIComponent(source)
            })
        }

        let analyzerItem = this.props.getPersistedData('analyzerItem');
        if (analyzerItem) {
            this.importItem(analyzerItem, 'analyzer');
            this.props.clearPersistedData('analyzerItem');
            this.setState({
                editMode: 'shared',
                postAction: 'share',
                whichEscapeHatch: 'back'
            });
        }
    }

    importItem(item, type) {
        let nextPostData = Utilities.deepClone(this.state.postData),
            nextSelectedSocials = {},
            nextMediaThumbs = [...this.state.mediaThumbs],
            nextVideoInfo = [...this.state.videoInfo],
            constants = this.props.app.config.constants,
            checkMsgForLink = false,
            checkSvc = 0,
            isLoading = this.state.isLoading,
            isLinkLoading = this.state.isLinkLoading;

        // last chance guard again some odd cloud errors
        if (item === undefined || !item) {
            return
        }

        if (type === 'curation') {
            if (item.id) {
                nextPostData.otherData.ci_id = item.id;
                nextPostData.otherData.deleteFlag = 1;
            }

            if (item.item) {
                if (item.item.title !== undefined && item.item.title) {
                    nextPostData.shared.message = item.item.title;
                }

                if (item.item.longUrl !== undefined && item.item.longUrl) {
                    nextPostData.shared.link = item.item.longUrl;
                    nextPostData.shared.message += (nextPostData.shared.message.length) ? ` ${item.item.longUrl}` : item.item.longUrl;
                    this.props.getUrlInfo(encodeURIComponent(item.item.longUrl));
                    isLinkLoading = true;
                }
            }
        } else if (type === 'queue') {
            let social = this.props.socials.list.find(({id}) => { return item.paID === id; });

            if (social) {
                this.props.filterStore('socials', ['psID'], social.id);
                nextSelectedSocials[social.psID] = [social.id];
                nextPostData.otherData.socialId = social.id;
                nextPostData.services[social.psID] = item.preview;
                if ([constants.POST_SVC_TWITTER, constants.POST_SVC_THREADS, constants.POST_SVC_BLUESKY].indexOf(social.psID) !== -1  && item.link === undefined) {
                    checkMsgForLink = true;
                    checkSvc = social.psID;
                    isLoading = true;
                }
                if (social.psID === constants.POST_SVC_GMYBUSINESS) {
                    nextPostData.services[social.psID] = this.transformGoogleData(item.preview, 'flatten');
                }
                if (item.preview.media !== undefined) {
                    nextPostData.services[social.psID].media = item.preview.media;
                }

                nextPostData.services[social.psID].id = item.id;

                if (item.preview.mb_id !== undefined && item.preview.mb_id && item.preview.media !== undefined) {
                    if (item.preview.media.length) {
                        for (let i = 0; i < item.preview.media.length; ++i) {
                            let media = item.preview.media[i];
                            nextMediaThumbs.push({
                                hash: media.hash,
                                mb_id: item.preview.mb_id,
                                thumb: media.thumb,
                                original: media.full,
                                type: media.mimeType
                            })
                            if (!nextPostData.services[social.psID].hashes) {
                                nextPostData.services[social.psID].hashes = [];
                            }
                            nextPostData.services[social.psID].hashes.push(media.hash);

                            if ((item.preview.image_state !== undefined && item.preview.image_state[media.hash] !== undefined) ||
                                (item.preview.cover_ms !== undefined && item.preview.cover_ms[media.hash] !== undefined)) {
                                let videoInfo = {
                                    hash: media.hash,
                                    serviceId: social.psID,
                                };
                                if (item.preview.image_state) {
                                    videoInfo.image_state = item.preview.image_state[media.hash];
                                }
                                if (item.preview.cover_ms) {
                                    videoInfo.cover_ms = item.preview.cover_ms[media.hash];
                                }
                                nextVideoInfo.push(videoInfo);
                            }
                        }
                    }
                }

                if (item.preview.link !== undefined && item.preview.link !== '') {
                    this.props.getUrlInfo(encodeURIComponent(item.preview.link));
                    isLinkLoading = true;
                }

                // unset the imageLink if the service does link previews
                if (item.preview.imageLink &&
                    item.preview.itemInfo !== undefined &&
                    item.preview.itemInfo.preview_display === 1) {
                    nextPostData.services[social.psID].imageLink = '';
                } else if (
                    item.preview.imageLink &&
                    item.preview.itemInfo !== undefined &&
                    item.preview.itemInfo.preview_display === 0
                ) {
                    // upload the image link and let it create a bundle
                    let formData = new FormData();
                    formData.append('type', 'postMedia');
                    formData.append('imageUrl', item.preview.imageLink);

                    MediaUploader({
                        formData,
                        onUploadProgress: () => {},
                        responseCallback: (response) => {
                            let data = response.data;

                            this.attachMedia(data, social.psID);

                        },
                        errorCallback: (error) => {
                            if (error.response) {
                                let errorData = error.response.data.errors || null,
                                    errorMsgs = [];

                                const extractErrors = (obj) => {
                                    if (obj && Object.keys(obj).length) {
                                        Object.keys(obj).map((key) => {
                                            if (typeof obj[key] === 'string') {
                                                errorMsgs.push(obj[key]);
                                            } else if (Object.keys(obj[key])) {
                                                extractErrors(obj[key]);
                                            }
                                        });
                                    }
                                };

                                // session died before upload
                                if (error.response.status === 403) {
                                    window.location.reload();
                                    return;
                                }

                                if (error.response.status === 413) {
                                    let mediaError = {};
                                    mediaError[social.psID] = "File too large to upload";

                                    this.updateMediaErrors(mediaError);
                                    return;
                                }

                                extractErrors(errorData);

                                if (errorMsgs.length) {
                                    if (this.state.service !== undefined) {
                                        let mediaError = {};
                                        mediaError[social.psID] = errorMsgs.join(" ");
                                        this.updateMediaErrors(mediaError);
                                    } else {
                                        this.setState({
                                            apiError: errorMsgs.join(" ")
                                        });
                                    }
                                } else if (error.response.data.error) {
                                    this.setState({
                                        apiError: `We couldn't complete your last request: ${error.response.data.error.msg}`
                                    });
                                }

                            } else if (error.message) {
                                if (this.state.service !== undefined) {
                                    let mediaError = {};
                                    mediaError[social.psID] = error.message;
                                    this.props.updateMediaErrors(mediaError);
                                } else {
                                    this.setState({
                                        apiError: error.message
                                    });
                                }
                            }
                        }
                    });
                }

                if (item.post_ts !== undefined && item.post_ts !== 0) {
                    nextPostData.services[social.psID].post_ts = parseInt(item.post_ts * 1000);
                }

            }
        } else if (type === 'repost' || type === 'analyzer') {
            if (item.preview) {
                if (item.preview.message !== undefined && item.preview.message) {
                    nextPostData.shared.message = item.preview.message;
                } else if (item.preview.title !== undefined && item.preview.title) {
                    nextPostData.shared.message = item.preview.title;
                }

                if (item.preview.longUrl !== undefined && item.preview.longUrl) {
                    nextPostData.shared.link = item.preview.longUrl;
                    this.props.getUrlInfo(encodeURIComponent(item.preview.longUrl));
                    isLinkLoading = true;
                } else if (item.preview.link !== undefined) {
                    nextPostData.shared.link = item.preview.link;
                    this.props.getUrlInfo(encodeURIComponent(item.preview.link));
                    isLinkLoading = true;
                }

                if (item.preview.mb_id !== undefined && item.preview.mb_id && item.preview.media !== undefined && item.preview.mb_id > 0) {
                    if (item.preview.media.length) {
                        for (let i = 0; i < item.preview.media.length; ++i) {
                            let media = item.preview.media[i];
                            nextMediaThumbs.push({
                                hash: media.hash,
                                mb_id: item.preview.mb_id,
                                thumb: media.thumb,
                                original: media.full,
                                type: media.mimeType
                            });
                            if (!nextPostData.shared.hashes) {
                                nextPostData.shared.hashes = [];
                            }
                            nextPostData.shared.hashes.push(media.hash);

                            if (item.preview.image_state !== undefined && item.preview.image_state[media.hash] !== undefined) {
                                nextVideoInfo.push({
                                    hash: media.hash,
                                    serviceId: 0,
                                    image_state: item.preview.image_state[media.hash]
                                });
                            }
                        }

                    }

                } else if (item.external_media !== undefined) {
                    let formData = new FormData();

                    item.external_media.map((media) => {
                       formData.append('imageUrl[]', media.src);
                    });

                    formData.append('type', 'postMedia');

                    MediaUploader({
                        formData,
                        onUploadProgress: () => {},
                        responseCallback: (response) => {
                            let data = response.data;

                            this.attachMedia(data);

                        },
                        errorCallback: (error) => {
                            if (error.response) {
                                let errorData = error.response.data.errors || null,
                                    errorMsgs = [];

                                const extractErrors = (obj) => {
                                    if (obj && Object.keys(obj).length) {
                                        Object.keys(obj).map((key) => {
                                            if (typeof obj[key] === 'string') {
                                                errorMsgs.push(obj[key]);
                                            } else if (Object.keys(obj[key])) {
                                                extractErrors(obj[key]);
                                            }
                                        });
                                    }
                                };

                                // session died before upload
                                if (error.response.status === 403) {
                                    window.location.reload();
                                    return;
                                }

                                if (error.response.status === 413) {
                                    this.setState({
                                        apiError: "File(s) too large to upload"
                                    });
                                    return;
                                }

                                extractErrors(errorData);

                                if (errorMsgs.length) {
                                    // no service errors in this context
                                    this.setState({
                                        apiError: errorMsgs.join(" ")
                                    });

                                } else if (error.response.data.error) {
                                    this.setState({
                                        apiError: `We couldn't complete your last request: ${error.response.data.error.msg}`
                                    });
                                }

                            } else if (error.message) {
                                // no service errors in this context
                                this.setState({
                                    apiError: error.message
                                });
                            }
                        }
                    });
                }

            }

        }

        this.setState({
            postData: nextPostData,
            selectedSocials: nextSelectedSocials,
            mediaThumbs: nextMediaThumbs,
            videoInfo: nextVideoInfo,
            isLoading,
            isLinkLoading
        }, () => {
            if (checkMsgForLink) {
                this.getUrlPreview(this.state.postData.services[checkSvc].message, checkSvc);
            }
        });
    }

    interactionCheck(e) {
        if (this.state.isEmojiPickerVisible) {
            if (this.emojiPickerRef.current && this.emojiPickerRef.current.contains(e.target)) {
                return;
            }
            this.setState({
                isEmojiPickerVisible: false
            });
        }
        if (this.state.showSortMenu) {
            if (this.sortMenuRef.current && this.sortMenuRef.current.contains(e.target)) {
                return;
            }
            this.setState({
                showSortMenu: false
            });
        }
    }

    getSelectedSocialCount() {
        let socialCount = 0;

        if (Object.keys(this.state.selectedSocials).length) {
            socialCount = Object.keys(this.state.selectedSocials).reduce((total, key) => {
                return total + this.state.selectedSocials[key].length;
            }, 0);
        }

        return socialCount;
    }

    onSocialClick(e) {
        e.preventDefault();

        let id = parseInt(e.currentTarget.dataset.socialid, 10),
            type = parseInt(e.currentTarget.dataset.socialtype, 10),
            nextSelectedSocials = Utilities.deepClone(this.state.selectedSocials),
            nextPostData = Utilities.deepClone(this.state.postData),
            nextValidationErrors = Utilities.deepClone(this.state.validationErrors),
            isSocialWarningVisible = this.state.isSocialWarningVisible,
            editMode = this.state.editMode,
            constants = this.props.app.config.constants;

        if (['edit-queue', 'edit-everqueue'].indexOf(editMode) !== -1) {
            return;
        }

        if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
            if (type === constants.POST_SVC_TWITTER) {
                return;
            }
        }

        // only a single youtube channel can be selected for manual posts
        if (type === constants.POST_SVC_YOUTUBE &&
            (_.isArray(nextSelectedSocials[type]) &&
            nextSelectedSocials[type].indexOf(id) === -1)) {
            return;
        }

        /*
         * Inactive accounts are listed rather than filtered out, so a click on
         * one is a request to bring it back, not to select it — there is nothing
         * to post to yet. The id is parked and perms refetched; componentDidUpdate
         * picks it up when USER_FETCH_PERMS settles and decides between the
         * upgrade prompt, a reconnect and a plain reactivation.
         */
        if (id) {
            let social = this.props.socials.list.find((candidate) => candidate.id === id),
                alreadySelected = (nextSelectedSocials[type] !== undefined &&
                    nextSelectedSocials[type].indexOf(id) !== -1);

            if (social && social.activeFlag === 0 && !alreadySelected) {
                this.setState({
                    reconnectingSocialId: id
                }, () => {
                    this.props.getUserPerms();
                });

                return;
            }
        }

        if (id) {
            if (nextSelectedSocials[type] !== undefined && nextSelectedSocials[type].indexOf(id) !== -1) {
                nextSelectedSocials[type].splice(nextSelectedSocials[type].indexOf(id), 1);
                if (nextSelectedSocials[type].length === 0) {
                    delete nextSelectedSocials[type];
                    delete nextPostData.services[type];
                    delete nextValidationErrors[type];
                }
                if (!Object.keys(nextPostData.services).length && editMode !== 'shared') {
                    editMode = 'shared';
                }

            } else {
                if (nextSelectedSocials[type] === undefined) {
                    nextSelectedSocials[type] = [];
                }
                nextSelectedSocials[type].push(id);

                let servicesToValidate = [];
                if (nextPostData.services[type] === undefined && editMode === 'network') {
                    nextPostData.services[type] = Utilities.deepClone(nextPostData.shared);
                    this.initService(nextPostData, type);
                    if (nextPostData.services[type].hashes !== undefined && nextPostData.services[type].hashes.length) {
                        servicesToValidate.push({
                            id: type,
                            hashes: [...nextPostData.shared.hashes]
                        });
                    }
                } else if (nextPostData.shared.hashes !== undefined && nextPostData.shared.hashes.length) {
                    servicesToValidate.push({
                        id: type,
                        hashes: [...nextPostData.shared.hashes]
                    });
                }

                if (servicesToValidate.length) {
                    this.props.getPostMediaValidation({
                        svcs: servicesToValidate
                    });
                }
            }

            if (Object.keys(nextSelectedSocials).length && this.state.isSocialWarningVisible) {
                isSocialWarningVisible = false;
            }

            this.setState({
                selectedSocials: nextSelectedSocials,
                postData: nextPostData,
                editMode,
                validationErrors: nextValidationErrors,
                isSocialWarningVisible
            });

        } else if (id === 0) {
            this.setState({
                saveState: true
            });

            // let the user connect a new social
            let modal = (
    				<SocialModal
    					{...this.props}
    					router={this.props.router}
    					context={'posting'}
    					recordPath={this.props.recordPath}
    					user={this.props.user}
                        closeCallback={() => {
                            this.props.deleteApiError(['SOCIAL_CREATE']);
                            this.sortSocialsByAvailability();
                        }} />
    			);

    		if (this.props.user.perms.resources.outputsAvailable == 0) {
    			this.props.showUpgradeModal(() => {
					this.props.deleteApiError(['SOCIAL_CREATE']);
					this.props.closeAllModals();
				}, 'socials', null, 'social_banner');
    		} else {
                // save state just in case
                this.props.persistData('postingState', this.state);
    			this.props.addModal(modal);
    		}

    		this.props.clearFilter('social');
        }

    }

    addSelectedSocial(socialId) {
        let social = this.props.socials.list.find(({id}) => { return id === socialId; }),
            nextSelectedSocials = Utilities.deepClone(this.state.selectedSocials);

        // this should only be called on load or after load when socials are present
        // but always in a 'shared' edit mode
        if (social) {
            if (nextSelectedSocials[social.psID] !== undefined) {
                nextSelectedSocials[social.psID].push(socialId);
            } else {
                nextSelectedSocials[social.psID] = [socialId];
            }

            this.setState({
                selectedSocials: nextSelectedSocials
            });
        }
    }

    showSortMenu() {

        this.setState({
            showSortMenu: (this.state.showSortMenu) ? false : true
        });

    }

    sortMenuHandler(e) {
        let action = e.target.dataset.action,
            dir = e.target.dataset.dir || '',
            nextUserPrefs = this.state.userPrefs;

        switch (action) {
            case 'sort':
                if (dir === 'type') {
                    this.props.sortStore('socials', 'psID', 'ASC');
                } else {
                    this.props.sortStore('socials', 'name', dir);
                }
                break;

            case 'chooseGroup':
                this.pushAccessoryModal('groups');
                break;

            case 'toggleSocialLabels':
                nextUserPrefs.showLabels = (nextUserPrefs.showLabels) ? false : true;
                this.setState({
                    userPrefs: nextUserPrefs
                }, () => {
                    this.props.persistData('postingPrefs', nextUserPrefs);
                });
                break;

            default:
                break;
        }

        this.setState({
            showSortMenu: false
        })
    }

    selectAllHandler(e) {
        let nextSelectedSocials = {},
            nextEditMode = this.state.editMode,
            nextPostData = Utilities.deepClone(this.state.postData),
            servciesToValidate = [],
            constants = this.props.app.config.constants;

        if (this.getSelectedSocialCount() !== this.props.socials.list.filter((social) => social.activeFlag === 1).length) {
            this.props.socials.list.map((social) => {
                if (social.activeFlag === 1) {
                    if (nextSelectedSocials[social.psID] === undefined) {
                        nextSelectedSocials[social.psID] = [];
                    }
                    if (social.psID === constants.POST_SVC_YOUTUBE && nextSelectedSocials[social.psID].length) {
                        return;
                    }
                    nextSelectedSocials[social.psID].push(social.id);
                    if (nextPostData.services[social.psID] === undefined && nextEditMode === 'network') {
                        nextPostData.services[social.psID] = Utilities.deepClone(nextPostData.shared);
                        this.initService(nextPostData, social.psID);
                        if (nextPostData.services[social.psID].hashes !== undefined && nextPostData.services[social.psID].hashes.length) {
                            let hashes = [...nextPostData.services[social.psID].hashes];
                            servciesToValidate.push({
                                id: social.psID,
                                hashes
                            });
                        }

                    } else if (nextEditMode === 'shared' && nextPostData.shared.hashes !== undefined && nextPostData.shared.hashes.length) {
                        servciesToValidate.push({
                            id: social.psID,
                            hashes: nextPostData.shared.hashes
                        });
                    }

                    if (servciesToValidate.length) {
                        this.props.getPostMediaValidation({
                            svcs: servciesToValidate
                        });
                    }
                }
            });
        } else {
            if (nextEditMode === 'network') {
                nextEditMode = 'shared';
                nextPostData.services = {};
            }
        }

        this.setState({
            selectedSocials: nextSelectedSocials,
            editMode: nextEditMode,
            postData: nextPostData
        });

    }

    toggleEmojiPicker(e) {

        if (this.emojiPickerRef.current && this.emojiPickerRef.current.contains(e.target)) {
            return;
        }

        this.setState({
            isEmojiPickerVisible: (this.state.isEmojiPickerVisible) ? false : true
        });

    }

    addEmoji(ref, emoji) {

        if (ref.current) {
            let startPos = ref.current.selectionStart,
                endPos = ref.current.selectionEnd,
                nextMessage = '';

            nextMessage = `${ref.current.value.substring(0, startPos)} ${emoji.emoji} ${ref.current.value.substring(endPos, ref.current.value.length)}`;

            ref.current.value = nextMessage;

            return nextMessage;
        }

    }

    showCategoryPicker(e) {
        let serviceId = parseInt(e.currentTarget.dataset.serviceid) || 0;

        if (this.state.accessoryModalStack.indexOf('category') === -1) {
            this.pushAccessoryModal('category');
        } else {
            this.popAccessoryModal();
        }

        this.setState({
            accessoryServiceId: serviceId
        });

    }

    addCategory(category) {
        let nextPostData = Utilities.deepClone(this.state.postData),
            nextPostAction = this.state.postAction;

        if (category) {
            if (!this.state.accessoryServiceId) {
                nextPostData.shared.tagID = category.id;
                nextPostData.shared.tagName = category.name;
            } else {
                if (nextPostData.services[this.state.accessoryServiceId]) {
                    nextPostData.services[this.state.accessoryServiceId].tagID = category.id;
                    nextPostData.services[this.state.accessoryServiceId].tagName = category.name;
                }
            }

            if (nextPostAction === 'schedule' && ['edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) === -1) {
                nextPostAction = 'save';
            } else if (nextPostAction !== 'save') {
                nextPostAction = 'queue';
            }

        }

        this.popAccessoryModal();

        this.setState({
            postData: nextPostData,
            accessoryServiceId: 0,
            postAction: nextPostAction
        });

    }

    attachMedia(data, service, previousHash) {
        let nextPostData = Utilities.deepClone(this.state.postData),
            nextMediaThumbs = [...this.state.mediaThumbs],
            constants = this.props.app.config.constants,
            i = 0;

        if (service) {
            for (i = 0; i < data.media.length; ++i) {
                if (nextPostData.services[service].hashes === undefined) {
                    nextPostData.services[service].hashes = [];
                }
                nextPostData.services[service].hashes.push(data.media[i].hash);
            }
            if (previousHash) {
                nextPostData.services[service].hashes.splice(nextPostData.services[service].hashes.indexOf(previousHash), 1);
            }
            if (nextPostData.services[service].hashes.length) {
                this.props.getPostMediaValidation({
                    svcs: [{
                        id: service,
                        hashes: nextPostData.services[service].hashes
                    }]
                });
            }
            if (nextPostData.services[service].link &&
                [constants.POST_SVC_GMYBUSINESS,
                 constants.POST_SVC_PINTEREST,
                 constants.POST_SVC_REDDIT].indexOf(parseInt(service)) === -1) {
                nextPostData.services[service].link = '';
            }
            if (nextPostData.services[service].imageLink) {
                delete nextPostData.services[service].imageLink;
            }

            if (data.unsplashData !== undefined) {
                nextPostData.services[service].message += ` Photo by ${data.unsplashData.username} via Unsplash`;
                delete data.unsplashData;
            }

        } else {
            for (i = 0; i < data.media.length; ++i) {
                nextPostData.shared.hashes.push(data.media[i].hash);
            }

            if (previousHash) {
                nextPostData.shared.hashes.splice(nextPostData.shared.hashes.indexOf(previousHash), 1);
            }

            // validate the new set of hashes
            if (nextPostData.shared.hashes.length) {
                let validationData = [];
                Object.keys(this.state.selectedSocials).map((service) => {
                    validationData.push({
                        id: service,
                        hashes: nextPostData.shared.hashes
                    });

                });
                if (validationData.length) {
                    this.props.getPostMediaValidation({
                        svcs: validationData
                    });
                }
            }
            if (nextPostData.shared.link) {
                nextPostData.shared.link = '';
            }
            // TODO figure out what to do with unsplash and multi
            if (data.unsplashData !== undefined) {
                nextPostData.shared.message += ` Photo by ${data.unsplashData.username} via Unsplash`;
                delete data.unsplashData;
            }
        }


        for (i = 0; i < data.media.length; ++i) {
            if (nextMediaThumbs.find((thumb) => { return thumb.hash === data.media[i].hash}) === undefined) {
                nextMediaThumbs.push(data.media[i]);
            }
        }

        if (previousHash) {
            let index = nextMediaThumbs.findIndex((thumb) => { return thumb.hash === previousHash; });
            if (index !== -1) {
                nextMediaThumbs.splice(index, 1);
            }
        }

        // need to handle form switching manually for tiktok
        if (service && parseInt(service) === constants.POST_SVC_TIKTOK) {
            this.setTikTokForm(nextPostData, nextMediaThumbs);
        }

        this.setState({
            postData: nextPostData,
            mediaThumbs: nextMediaThumbs
        });

    }

    removeThumb(hash, service, callback) {
        let nextMediaThumbs = [],
            refCount = 0,
            nextPostData = Utilities.deepClone(this.state.postData),
            nextApiErrors = Utilities.deepClone(this.state.apiErrors),
            restoreLink = false,
            constants = this.props.app.config.constants;

        if (service) {
            Object.keys(this.state.postData.services).map((serviceId) => {
                if (serviceId !== service &&
                    this.state.postData.services[serviceId].hashes !== undefined &&
                    this.state.postData.services[serviceId].hashes.length &&
                    this.state.postData.services[serviceId].hashes.indexOf(hash) >= 0) {
                    refCount++;
                }
            });
            // preserve the thumb if there is at least 1 reference in another service
            for (let i = 0; i < this.state.mediaThumbs.length; ++i) {
                if (this.state.mediaThumbs[i].hash === hash && refCount >= 1) {
                    nextMediaThumbs.push(this.state.mediaThumbs[i]);
                } else if (this.state.mediaThumbs[i].hash !== hash) {
                    nextMediaThumbs.push(this.state.mediaThumbs[i]);
                }
            }

            if (nextPostData.services[service].hashes.indexOf(hash) !== -1) {
                nextPostData.services[service].hashes.splice(nextPostData.services[service].hashes.indexOf(hash), 1);
                if (nextPostData.services[service].hashes.length) {
                    this.props.getPostMediaValidation({
                        svcs: [{
                            id: service,
                            hashes: nextPostData.services[service].hashes
                        }]
                    });
                }
            }

            if (nextApiErrors[service] !== undefined && nextApiErrors[service].mb_id !== undefined) {
                if (Object.keys(nextApiErrors[service]).length === 1) {
                    delete nextApiErrors[service];
                } else {
                    delete nextApiErrors[service].mb_id;
                }
            }

            if (nextPostData.services[service].hashes.length === 0 && nextPostData.services[service].mb_id !== undefined) {
                delete nextPostData.services[service].mb_id;
                // if all hashes are removed, also check the content for a link and do a link preview if necessary
                restoreLink = true;
            }

        }  else {
            if (this.state.postData.shared.hashes.indexOf(hash) >= 0) {
                for (let i = 0; i < this.state.mediaThumbs.length; ++i) {
                    if (this.state.mediaThumbs[i].hash !== hash) {
                        nextMediaThumbs.push(this.state.mediaThumbs[i]);
                    }
                }
            }

            if (nextPostData.shared.hashes.length) {
                nextPostData.shared.hashes.splice(nextPostData.shared.hashes.indexOf(hash), 1);
            }

            // if all images are removed check if there's a link in the message
            if (nextPostData.shared.hashes.length === 0) {
                restoreLink = true;

            }

            let validationData = [];
            Object.keys(this.state.selectedSocials).map((service) => {
                validationData.push({
                    id: service,
                    hashes: nextPostData.shared.hashes
                });

            });
            if (validationData.length) {
                this.props.getPostMediaValidation({
                    svcs: validationData
                });
            }
        }

        // need to handle form switching manually for tiktok
        if (service && parseInt(service) === constants.POST_SVC_TIKTOK) {
            this.setTikTokForm(nextPostData, nextMediaThumbs);
        }

        this.setState({
            mediaThumbs: nextMediaThumbs,
            postData: nextPostData,
            apiErrors: nextApiErrors
        }, () => {
            if (restoreLink) {
                if (service) {
                    this.getUrlPreview(this.state.postData.services[service].message, service);
                } else {
                    this.getUrlPreview(this.state.postData.shared.message);
                }
            }
            if (callback && typeof callback === 'function') {
                callback();
            }
        });

    }

    changeEditMode() {
        let nextPostData = Utilities.deepClone(this.state.postData),
            nextVideoInfo = [...this.state.videoInfo],
            selectedServices = Object.keys(this.state.selectedSocials),
            constants = this.props.app.config.constants;

        selectedServices.map((serviceId) => {
            nextPostData.services[serviceId] = Utilities.deepClone(nextPostData.shared);
            this.addLinkInfoToPostData(nextPostData, parseInt(serviceId));
            // add any service specific defaults here
            this.initService(nextPostData, serviceId);

            // make service specific copies of any video info
            for (let i = 0; i < this.state.videoInfo.length; ++i) {
                if (this.state.videoInfo[i].serviceId === 0) {
                    let newVideoInfo = Utilities.deepClone(nextVideoInfo[i]);
                    newVideoInfo.serviceId = parseInt(serviceId);
                    nextVideoInfo.push(newVideoInfo);
                }
            }
        });

        // remove the shared tag when switching to network mode
        if (nextPostData.shared.tagID !== undefined) {
            delete nextPostData.shared.tagID;
        }

        this.setState({
            postData: nextPostData,
            videoInfo: nextVideoInfo,
            editMode: 'network'
        });

    }

    getCharCount(message, serviceID) {

        let offset = 0,
            linksInMessage = null,
            constants = this.props.app.config.constants;

        if (message && _.isString(message)) {
            linksInMessage = message.match(urlRegex);
        } else {
            return 0;
        }

        if (serviceID) {
            serviceID = parseInt(serviceID, 10);
            if ([constants.POST_SVC_TWITTER, constants.POST_SVC_MASTODON].indexOf(serviceID) !== -1) {

                if (linksInMessage) {
                    for (let i = 0; i < linksInMessage.length; i++) {
                        offset += linksInMessage[i].length - 24;
                    }
                } else {
                    if (this.state.postData.services[serviceID] !== undefined && this.state.postData.services[serviceID].link) {
                        return message.length + 24;
                    }
                }

                return message.length - offset;
            }
        }

        return message.length;

    }

    getUrlPreview(text, service, fieldName) {
        let search = urlRegex.exec(text),
            nextPostData = Utilities.deepClone(this.state.postData),
            constants = this.props.app.config.constants,
            postErrors = this.state.postErrors,
            isLoading = this.state.isLoading,
            isLinkLoading = this.state.isLinkLoading;

        if (search) {
            let url = search[0];

            // don't try to get a preview for a link that's already errored
            if (this.state.linksWithErrors.indexOf(url) !== -1) {
                return;
            }

            // if the fieldName is set it means the field will be filled in by
            // requestChange and doesn't need to be explicitly set on postData
            // if (!fieldName) {
                if (service) {
                    nextPostData.services[service].link = url;
                } else {
                    nextPostData.shared.link = url;
                }
            // }

            if (this.state.linkPreviews[url] === undefined) {
                this.props.getUrlInfo(encodeURIComponent(url));
                isLinkLoading = true;
            } else {
                // since we have a link preview add any extra info to the service data
                if (service) {
                    this.addLinkInfoToPostData(nextPostData, parseInt(service));
                }
            }

        } else {
            // no url found in the text, do we need to unset the link?
            service = parseInt(service);
            if ([constants.POST_SVC_TWITTER, constants.POST_SVC_THREADS].indexOf(service) !== -1) {
                if (!_.isEmpty(nextPostData.services[service].link)) {
                    let link = this.state.linkPreviews[nextPostData.services[service].link];

                    if (service === constants.POST_SVC_TWITTER) {
                        if (link && link.twitter_preview !== undefined && link.twitter_preview === false) {
                            nextPostData.services[service].link = '';
                        }
                    } else if ([constants.POST_SVC_THREADS].indexOf(service) !== -1) {
                        if (link) {
                            nextPostData.services[service].link = '';
                        }
                    }
                }
            }
            isLoading = false;
        }

        this.setState({
            postData: nextPostData,
            postErrors: [],
            isLoading,
            isLinkLoading
        });

    }

    removeLink(e) {
        let service = parseInt(e.currentTarget.dataset.servicetype, 10) || 0,
            nextPostData = Utilities.deepClone(this.state.postData),
            nextLinkPreviews = Utilities.deepClone(this.state.linkPreviews);

        if (service) {
            let link = nextPostData.services[service].link,
                deletePreview = true;

            nextPostData.services[service].link = '';
            if (nextPostData.services[service].imageLink !== undefined) {
                delete nextPostData.services[service].imageLink;
            }
            Object.keys(nextPostData.services).map((key) => {
                if (nextPostData.services[key].link === link) {
                    deletePreview = false;
                }
            });

            if (deletePreview) {
                delete nextLinkPreviews[link];
            }

        } else {
            delete nextLinkPreviews[nextPostData.shared.link];
            nextPostData.shared.link = '';
        }

        this.setState({
            postData: nextPostData,
            linkPreviews: nextLinkPreviews
        });

    }

    postActionHandler(action) {
        let nextPostErrors = [...this.state.postErrors],
            nextPostData = Utilities.deepClone(this.state.postData),
            callback = null,
            isWorking = this.state.isWorking,
            constants = this.props.app.config.constants;

        if (Object.keys(this.state.validationErrors).length && this.state.editMode === 'shared') {
            if (nextPostErrors.find((message) => { return _.isString(message) && message.match("Please review the errors"); }) === undefined) {
                nextPostErrors.push("Please review the errors below before posting.");
                this.setState({
                    postErrors: nextPostErrors
                });
                this.changeEditMode()
            }
            return;
        }

        if (Object.keys(this.state.selectedSocials).length === 0) {
            if (this.state.isSocialWarningVisible === false) {
                this.setState({
                    isSocialWarningVisible: true
                });
            }
            return;
        }

        switch (action) {
            case 'share':
                nextPostData.params.postFlag = constants.POST_NOW;
                callback = this.makePost;
                isWorking = true;
                break;

            case 'queue':
            case 'next':
                nextPostData.params.postFlag = constants.POST_QUEUE;
                if (action === 'next') {
                    nextPostData.params.rk_pref = 1;
                }
                callback = this.makePost;
                isWorking = true;
                break;

            case 'sharequeue':
                let now = new moment().format('X');
                callback = this.makePost;
                isWorking = true;
                Object.keys(nextPostData.services).map((service) => {
                    nextPostData.params.post_ts = parseInt(now);
                });
                break;

            case 'shareeverqueue':
                callback = this.makePost;
                isWorking = true;
                nextPostData.otherData.shareNowFlag = 1;
                break;

            case 'schedule':
                nextPostData.params.postFlag = constants.POST_QUEUE;
                if (this.validateServices(true)) {
                    this.pushAccessoryModal('scheduler');
                }
                break;

            case 'everqueue':
                nextPostData.params.postFlag = constants.POST_POOL;
                if (this.validateServices(true)) {
                    this.pushAccessoryModal('everqueue');
                }
                break;

            case 'save':
                callback = this.makePost;
                isWorking = true;
                break;

            case 'editschedule':
                if (this.validateServices(true)) {
                    this.pushAccessoryModal('scheduler');
                }
                break;

            default:
                break;
        }

        this.setState({
            postAction: action,
            postData: nextPostData,
            isWorking
        }, () => {
            if (callback) {
                callback.apply(this, []);
            }
        });

    }

    makePost() {
          let postContent = {
                ci_id: 0,
                content: {},
                params: {},
                accounts: []
            },
            constants = this.props.app.config.constants,
            cleanedData = {};

        const cleanPostData = (data, key) => {
            let clone = Utilities.deepClone(data),
                keys = Object.keys(clone),
                constants = this.props.app.config.constants;

            keys.map((key) => {
                if (_.isEmpty(clone[key]) && !_.isNumber(clone[key]) && !_.isBoolean(clone[key])) {
                    delete clone[key];
                } else if (_.isObject(clone[key]) && !_.isArray(clone[key])) {
                    clone[key] = cleanPostData(clone[key]);
                } else if (_.isString(clone[key])) {
                    clone[key] = clone[key].trim();
                } else if (_.isBoolean(clone[key])) {
                    clone[key] = clone[key];
                }
            });

            if ([constants.POST_SVC_PINTEREST, constants.POST_SVC_GMYBUSINESS].indexOf(parseInt(key)) === -1) {
                if ((clone.mb_id !== undefined && _.isNumber(clone.mb_id) && clone.mb_id > 0) ||
                    (clone.hashes !== undefined && clone.hashes.length > 0)) {
                    if (clone.link !== undefined && clone.link !== '') {
                        delete clone.link;
                    }
                    if (clone.imageLink !== undefined && clone.imageLink !== '') {
                        delete clone.imageLink;
                    }
                }
            }

            return clone;
        }

        const assignVideoInfo = (content, key) => {
            if (content.hashes !== undefined && content.hashes.length) {
                content.hashes.map((mediaHash) => {
                    let video = null
                    if (key) {
                        video = this.state.videoInfo.find(({ hash, serviceId }) => { return mediaHash === hash && serviceId === parseInt(key);});
                    } else {
                        video = this.state.videoInfo.find(({hash}) => { return mediaHash === hash; });
                    }
                    if (video && video.image_state) {
                        if (content.image_state === undefined) {
                            content.image_state = {};
                        }
                        content.image_state[mediaHash] = video.image_state;
                    }
                    if (video && video.cover_ms) {
                        if (content.cover_ms === undefined) {
                            content.cover_ms = {};
                        }
                        content.cover_ms[mediaHash] = Math.floor(video.cover_ms);
                    }
                });
            }
        }

        // copy in misc parameters (curation id, delete flag, etc)
        Object.keys(this.state.postData.otherData).map((key) => {
            postContent[key] = this.state.postData.otherData[key];
        });

        // copy in the post params
        postContent.params = Utilities.deepClone(this.state.postData.params);

        // prepare the post data
        if (this.state.editMode === 'shared') {
            Object.keys(this.state.selectedSocials).map((key) => {
                postContent.content[key] = cleanPostData(this.state.postData.shared, key);
            });
            // set the post data for each service in case of errors
            let nextPostData = Utilities.deepClone(this.state.postData);
            Object.keys(this.state.selectedSocials).map((key) => {
                nextPostData.services[key] = Utilities.deepClone(this.state.postData.shared);
                this.initService(nextPostData, key);
                if (nextPostData.services[key].link !== undefined && nextPostData.services[key].link) {
                    this.addLinkInfoToPostData(nextPostData, parseInt(key));
                }
                postContent.content[key] = cleanPostData(Utilities.deepClone(nextPostData.services[key]), key);
                assignVideoInfo(postContent.content[key], 0);
            });
            this.setState({
                postData: nextPostData
            });
        } else {
            Object.keys(this.state.postData.services).map((key) => {
                postContent.content[key] = cleanPostData(this.state.postData.services[key], key);
                assignVideoInfo(postContent.content[key], key);
            });
        }

        this.inferFormType(postContent);

        // now that we know the form type walk the data and see if
        // the itemInfo needs to be added
        Object.keys(postContent.content).map((key) => {
            this.addItemInfoDecorator(postContent.content[key], parseInt(key));
        });

        // validate against the form type
        if (!this.validateServices(true)) {
            this.setState({
                isWorking: false
            });
            return;
        } else {
            // reset the apiErrors/postErrors to see if we get a new batch
            this.setState({
                apiErrors: {},
                postErrors: []
            });
        }

        // google validation is done client side in a flattened state, but
        // the object has to be transformed in a way that the api will understand
        // do that now if necessary
        if (postContent.content[constants.POST_SVC_GMYBUSINESS] !== undefined) {
            postContent.content[constants.POST_SVC_GMYBUSINESS] = this.transformGoogleData(postContent.content[constants.POST_SVC_GMYBUSINESS], 'object');
        }

        if (['edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) !== -1) {
            // remove the service key from the content because that's what the backend wants
            let contentKeys = Object.keys(postContent.content),
                action = (this.state.editMode === 'edit-queue') ? this.props.updateQueue : this.props.updateEverqueue,
                queueContent = {};

            // for an edited item there shouldn't be more than a single service key
            queueContent.content = postContent.content[contentKeys[0]];
            queueContent.id = postContent.content[contentKeys[0]].id;
            queueContent.params = Utilities.deepClone(this.state.postData.params);
            delete queueContent.content.id;
            if (this.state.postData.params.post_times !== undefined) {
                // because nothing is consistent, on schedule edit set post_ts instead of post_times
                if (this.state.postData.params.post_times.length) {
                    queueContent.params.post_ts = this.state.postData.params.post_times[0];
                }
            }

            // copy in the share now flag for everqueue items
            if (postContent.shareNowFlag !== undefined && postContent.shareNowFlag === 1) {
                queueContent.shareNowFlag = 1;
            }

            action.apply(this, [this.state.postData.otherData.socialId, queueContent]);

        }  else {
            // add the selected socials
            Object.keys(this.state.selectedSocials).map((key) => {
                this.state.selectedSocials[key].map((id) => {
                    // There's an edge case where a social can be added in the post tool,
                    // then saved when the user leaves the page to delete it and then be present
                    // in the saved state when they come back, so guard against that
                    let social = this.props.socials.list.find((social) => { return social.id === id});
                    if (social) {
                        postContent.accounts.push(id);
                    }
                });
            });
            this.props.createPost(postContent);
        }


    }

    inferFormType(postContent) {

        let content = {};
        // can be called when posting after the data has been transformed to what postplus_api expects
        // but can also be called to guess a form type while the editing is in process
        if (postContent.content !== undefined) {
            content = postContent.content;
        } else if (postContent.services !== undefined) {
            content = postContent.services;
        } else {
            return;
        }


        if (Object.keys(content).length) {
            Object.keys(content).map((key) => {
                let validator = this.props.posts.postValidators[key];

                // the following services form types can be selected
                // don't try to guess if it's already set
                let constants = this.props.app.config.constants;
                if ([constants.POST_SVC_SNAPCHAT, constants.POST_SVC_GMYBUSINESS, constants.POST_SVC_REDDIT].indexOf(parseInt(key)) !== -1  && content[key].form !== undefined) {
                    return;
                }

                // tiktok needs to be detected separately since it depends on the type of media attached
                if (parseInt(key) === constants.POST_SVC_TIKTOK) {
                    if (this.getMediaCount(['image']) >= 1) {
                        content[key].form = 'photo_post';
                    } else if (this.getMediaCount(['video']) >= 1) {
                        content[key].form = 'video_post';
                    }
                    return;
                }

                if (validator) {
                    let formRanks = [];
                    Object.keys(validator.forms).map((formKey) => {
                        let form = validator.forms[formKey],
                            meetsAnyCount = 0,
                            meetsAll = null,
                            optionalCount = 0,
                            formFields = [];

                        if (form.requires.any !== undefined) {
                            formFields = gatherFields(form.requires.any, validator, 'any');
                            meetsAnyCount = _.reduce(formFields, (tally, field) => {
                                return (tally + (content[key][field] !== undefined && content[key][field])) ? 1 : 0;
                            }, 0);
                        }
                        if (form.requires.all !== undefined) {
                            formFields = gatherFields(form.requires.all, validator, 'all');
                            meetsAll = _.reduce(formFields, (valid, field) => {
                                return (valid && (content[key][field] !== undefined && content[key][field])) ? true : false;
                            }, true);
                        }
                        if (form.optional !== undefined) {
                            formFields = gatherFields(form.optional, validator, 'optional');
                            optionalCount = _.reduce(formFields, (tally, field) => {
                                return (tally + (content[key][field] !== undefined && content[key][field])) ? 1 : 0;
                            }, 0);
                        }

                        let formRank = {
                            name: formKey,
                            rank: 0
                        };
                        if (meetsAnyCount !== null && meetsAnyCount) {
                            formRank.rank += meetsAnyCount;
                        }
                        if (meetsAll !== null && meetsAll) {
                            formRank.rank++;
                        }
                        if (optionalCount > 0) {
                            formRank.rank += optionalCount;
                        }
                        formRanks.push(formRank);
                    });

                    let formMax = _.max(formRanks, (form) => { return form.rank; }),
                        formMin = _.min(formRanks, (form) => { return form.rank; }),
                        form = null;

                    if (formMax.rank === formMin.rank) {
                        content[key].form = this.formDefaults[key];
                    } else {
                        content[key].form = formMax.name;
                    }

                }
            });
        }

    }

    getMediaCount(type) {
        let count = 0;

        this.state.mediaThumbs.map((thumb) => {
            if (type === 'image' && thumb.type.match(/image/)) {
                count++;
            } else if (type === 'video' && thumb.type.match(/video/)) {
                count++;
            }
        });

        return count;
    }

    validateServices(finalCheck) {
        let serviceList = Object.keys(this.state.selectedSocials),
            nextValidationErrors = {},
            isValid = true,
            postData = this.state.postData.shared,
            constants = this.props.app.config.constants,
            fieldList = [];

        const setError = (service, field, error) => {
            isValid = false;

            if (nextValidationErrors[service] === undefined) {
                nextValidationErrors[service] = {};
            }
            if (nextValidationErrors[service][field] === undefined) {
                nextValidationErrors[service][field] = error;
            }

        }

        const fieldIsValid = (field) => {
            if (field === undefined || (_.isEmpty(field) && !_.isNumber(field) && !_.isBoolean(field))) {
                return false;
            }

            if (_.isString(field)) {
                if (field.trim().length === 0) {
                    return false;
                }
            }

            return true;
        }

        const validateForm = (validator, service, form, isOptionalForm) => {
            // check that for the selected forms any required fields are present
            if (form.requires !== undefined) {
                if (form.requires.all !== undefined) {
                    fieldList = form.requires.all;
                    if (parseInt(service) === constants.POST_SVC_GMYBUSINESS) {
                        fieldList = gatherFields(form.requires.all, validator, 'all');
                    }

                    // if the form is specified as optional AND
                    // none of the fields are in the postData, keep on truckin
                    if (isOptionalForm) {
                        let doValidation = false;
                        fieldList.map((field) => {
                            if (postData[field] !== undefined) {
                                doValidation = true;
                            }
                        });
                        if (!doValidation) {
                            return;
                        }
                    }

                    fieldList.map((field) => {
                        if (!fieldIsValid(postData[field])) {
                            // imageLink might be able to sub for mb_id in certain services
                            if (field === 'mb_id') {
                                if (fieldIsValid(postData.imageLink)) {
                                    return;
                                }

                                if (postData.hashes !== undefined && postData.hashes.length) {
                                    return;
                                }

                                if (this.linklessServices.indexOf(parseInt(service)) !== -1) {
                                    if (this.state.editMode === 'shared') {
                                        if (this.state.postData.shared.link && this.state.linkPreviews[this.state.postData.shared.link] !== undefined) {
                                            // phew! so to keep a validation error from triggering in the shared mode
                                            // check if the data can be filled in at post time, and if so don't return an error
                                            return;
                                        }
                                    }
                                }
                            }
                            if (field === 'title') {
                                if (this.populateTitleForServices.indexOf(parseInt(service)) !== -1) {
                                    if (this.state.editMode === 'shared') {
                                        if (this.state.postData.shared.link && this.state.linkPreviews[this.state.postData.shared.link] !== undefined) {
                                            // phew! so to keep a validation error from triggering in the shared mode
                                            // check if the data can be filled in at post time, and if so don't return an error
                                            return;
                                        }
                                    }
                                }
                            }
                            // link can be empty in the case of Google when the cta_type (button) is unspecified or call
                            if (field === 'link' && postData.cta_type !== undefined && ['ACTION_TYPE_UNSPECIFIED', 'CALL'].indexOf(postData.cta_type) >= 0) {
                                return;
                            }
                            setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} requires ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')}`);
                        } else {
                            // add additional validation for mb_id
                            if (field === 'mb_id' && postData[field] === 0) {
                                // do a little something special for pinterest
                                // while they do require media, if a link has media we'll use imageLink
                                // and download the image for use in the pin
                                if (parseInt(service) === constants.POST_SVC_PINTEREST) {
                                    if (postData.link && this.state.linkPreviews[postData.link] !== undefined && this.state.linkPreviews[postData.link].media.length) {
                                        return;
                                    }
                                }
                                // check for hashes if mb_id is 0
                                if (postData.hashes === undefined || !postData.hashes.length) {
                                    setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} requires ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')}`);
                                }
                            }
                        }
                    });
                }
                if (form.requires.any !== undefined) {
                    let anyMet = false,
                        fieldNames = [];

                    fieldList = form.requires.any;
                    if (parseInt(service) === constants.POST_SVC_GMYBUSINESS) {
                        fieldList = gatherFields(form.requires.any, validator, 'any');
                    }

                    fieldList.map((field) => {
                        if (fieldIsValid(postData[field])) {
                            if (field === 'mb_id' && postData[field] === 0) {
                                // check for hashes if mb_id is 0
                                if (postData.hashes !== undefined && postData.hashes.length) {
                                    anyMet = true;
                                }
                            } else {
                                anyMet = true;
                            }
                        } else {
                            if (field === 'mb_id') {
                                if (postData.hashes !== undefined && postData.hashes.length) {
                                    anyMet = true;
                                } else if (fieldIsValid(postData.imageLink)) {
                                    anyMet = true;
                                }
                                if (this.linklessServices.indexOf(parseInt(service)) !== -1) {
                                    if (this.state.editMode === 'shared') {
                                        if (this.state.postData.shared.link && this.state.linkPreviews[this.state.postData.shared.link] !== undefined) {
                                            // phew! so to keep a validation error from triggering in the shared mode
                                            // check if the data can be filled in at post time, and if so don't return an error
                                            anyMet = true;
                                        }
                                    }
                                }
                            }
                            if (field === 'title') {
                                if (this.populateTitleForServices.indexOf(parseInt(service)) !== -1) {
                                    if (this.state.editMode === 'shared') {
                                        if (this.state.postData.shared.link && this.state.linkPreviews[this.state.postData.shared.link] !== undefined) {
                                            // phew! so to keep a validation error from triggering in the shared mode
                                            // check if the data can be filled in at post time, and if so don't return an error
                                            anyMet = true;
                                        }
                                    }
                                }
                            }
                        }
                        fieldNames.push(LabelLibrary.getStringsForField(service, field, 'fieldLabel'));
                    });

                    if (!anyMet) {
                        fieldNames.map((field) => {
                            setError(service, 'form', `${ConstantMixin.getPostServiceNameByCode(service)} requires one of the following: ${fieldNames.join(', ')}`);
                        });
                    }
                }
            }
        }

        const hasMixedMedia = () => {
            let hasImage = false,
                hasVideo = false;

            this.state.mediaThumbs.map((thumb) => {
                if (thumb.type.match(/image/)) {
                    hasImage = true;
                } else if (thumb.type.match(/video/)) {
                    hasVideo = true;
                }
            });

            return (hasImage && hasVideo) ? true : false;
        }

        serviceList.map((service) => {
            let validator = this.props.posts.postValidators[service],
                form = {},
                postDataCopy = Utilities.deepClone(this.state.postData);

            // if the service has a media validation error don't try and post
            if (this.state.mediaErrors[service] !== undefined) {
                isValid = false;
                return;
            }

            if (postDataCopy.services === undefined || postDataCopy.services[service] === undefined) {
                // treat the post data as if it were expanded into service level so the proper
                // form can be used to get the right validation in shared mode
                postDataCopy.services[service] = Utilities.deepClone(postDataCopy.shared);
                this.addLinkInfoToPostData(postDataCopy, parseInt(service));
                this.initService(postDataCopy, service);
                postData = postDataCopy.services[service];
            }

            if ([constants.POST_SVC_GMYBUSINESS,
                 constants.POST_SVC_REDDIT,
                 constants.POST_SVC_SNAPCHAT,
                 constants.POST_SVC_TIKTOK].indexOf(parseInt(service)) === -1) {
                this.inferFormType(postDataCopy);
            }

            postData = postDataCopy.services[service];

            if (validator) {
                let fields = validator.fields,
                    fieldKeys = Object.keys(validator.fields),
                    formKeys = Object.keys(validator.forms),
                    tagRegEx = /[^#]*?(#\w+)/g,
                    mentionRegEx = /[^@]*?(@\w+)/g;

                if (postData.form) {
                    form = validator.forms[postData.form];
                } else {
                    form = validator.forms[this.formDefaults[service]];
                }

                // check if the available fields have acceptable values
                fieldKeys.map((field) => {
                    if (field === 'form') {
                        return;
                    }

                    if (fields[field].type === "text" || fields[field].type === "url") {
                        if (finalCheck) {
                            if (fields[field].min_length !== undefined && postData[field] !== undefined && postData[field].length < fields[field].min_length) {
                                setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} requires the ${LabelLibrary.getStringsForField(service, field, 'fieldName')} to be at least ${fields[field].min_length} characters long.`);
                            }
                        }
                        if (field === 'message') {
                            let messageLength = this.getCharCount(postData[field], service);
                            if (fields[field].max_length !== undefined && postData[field] !== undefined && messageLength > fields[field].max_length) {
                                setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} requires the ${LabelLibrary.getStringsForField(service, field, 'fieldName')} to be no longer than ${fields[field].max_length} characters.`);
                            }
                            // only check for tags if there's message data (some services don't require a message e.g. IG)
                            if (postData[field] && fields[field].max_tags) {
                                let tagCount = [...postData[field].matchAll(tagRegEx)];
                                if (tagCount.length > fields[field].max_tags) {
                                    setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} allows a maximum of ${fields[field].max_tags} hashtags per post.`);
                                }
                            }
                            if (postData[field] && fields[field].max_mentions) {
                                let mentionCount = [...postData[field].matchAll(mentionRegEx)];
                                if (mentionCount.length > fields[field].max_mentions) {
                                    setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} allows a maximum of ${fields[field].max_mentions} mentions per post.`);
                                }
                            }
                        } else {
                            if (fields[field].max_length !== undefined && postData[field] !== undefined && postData[field].length > fields[field].max_length) {
                                setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} requires the ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')} to be no longer than ${fields[field].max_length} characters.`);
                            }
                        }
                    } else if (fields[field].type === 'enum') {
                        if (postData[field] !== undefined && fields[field].values.indexOf(postData[field]) === -1) {
                            setError(service, field, `Please choose a valid value for ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')}.`);
                        }
                    } else if (fields[field].type === 'bool') {
                        if (postData[field] !== undefined &&
                            (postData[field] !== true && postData[field] !== false) &&
                            (postData[field] !== 1 && postData[field] !== 0)) {
                            setError(service, field, `Please choose a valid value for ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')}.`);
                        }
                    } else if (fields[field].type === 'custom') {
                        if (parseInt(service) === constants.POST_SVC_GMYBUSINESS) {
                            if (postData.form !== undefined && (postData.form === 'OFFER' || postData.form === 'EVENT')) {
                                if (postData.schedule === undefined || (postData.schedule !== undefined && postData.schedule.startDate === undefined)) {
                                    setError(service, 'startDate', `${ConstantMixin.getPostServiceNameByCode(service)} requires a start date.`);
                                } else if (postData.schedule !== undefined && postData.schedule.startDate !== undefined) {
                                    let date = convertObjectToDate(postData.schedule.startDate, false, this.props.user.detail.timezone),
                                        now = new moment();

                                    if (date < now) {
                                        setError(service, 'startDate', `${ConstantMixin.getPostServiceNameByCode(service)} requires a start date in the future.`);
                                    }
                                }
                                if (postData.schedule === undefined || (postData.schedule !== undefined && postData.schedule.endDate === undefined)) {
                                    setError(service, 'endDate', `${ConstantMixin.getPostServiceNameByCode(service)} requires an end date`);
                                } else if (postData.schedule !== undefined && postData.schedule.endDate !== undefined) {
                                    let date = convertObjectToDate(postData.schedule.endDate, false, this.props.user.detail.timezone),
                                        startDate = (postData.schedule.startDate) ? convertObjectToDate(postData.schedule.startDate, false, this.props.user.detail.timezone) : null,
                                        now = new moment();

                                    if (date < now) {
                                        setError(service, 'endDate', `${ConstantMixin.getPostServiceNameByCode(service)} requires an end date in the future.`);
                                    }
                                    if (!startDate || (date < startDate)) {
                                        setError(service, 'endDate', `${ConstantMixin.getPostServiceNameByCode(service)} requires the end date to be after the start date.`);
                                    }
                                }
                            }
                        } else if (parseInt(service) === constants.POST_SVC_YOUTUBE) {
                            if (postData.tags !== undefined && postData.tags.length) {
                                let tagLength = 0,
                                    tagCommas = postData.tags.length - 1;

                                postData.tags.map((tag) => {
                                    // count quotes if there's space
                                    if (tag.match(" ")) {
                                        tagLength += tag.length + 2
                                    } else {
                                        tagLength += tag.length;
                                    }
                                });

                                tagLength += tagCommas;

                                if (fields[field].max_length !== undefined) {
                                    if (tagLength > fields[field].max_length) {
                                        setError(service, 'tags', `${ConstantMixin.getPostServiceNameByCode(service)} tags may not exceed ${fields[field].max_length} characters.`);
                                    }
                                }
                            }
                        }
                    } else if (fields[field].type === 'array') {
                        if (postData[field] !== undefined) {
                            switch (fields[field].value_type) {
                                case 'string':
                                    Object.keys(postData[field]).map((key) => {
                                        if (postData[field][key] > fields[field].max_length) {
                                            setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)}  ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')} fields may not exceed ${fields[field].max_length} characters.`);
                                        }
                                    });
                                    break;

                                case 'int':
                                    Object.keys(postData[field]).map((key) => {
                                        if (postData[field][key] > fields[field].max || postData[field][key] < fields[field].min) {
                                            setError(service, field, `${ConstantMixin.getPostServiceNameByCode(service)} ${LabelLibrary.getStringsForField(service, field, 'fieldLabel')} values must be a valid number.`);
                                        }
                                    });
                                    break;

                                default:
                                    break;
                            }

                        }
                    }

                });

                validateForm(validator, service, form, false);

                if (parseInt(service) === constants.POST_SVC_GMYBUSINESS) {
                    // check that embedded forms meet the requirements
                    const checkForSubforms = (validator, service, fields, isOptionalForm) => {
                        fields.map((key) => {
                            if (formKeys.indexOf(key) !== -1) {
                                validateForm(validator, service, validator.forms[key], isOptionalForm);
                            }
                        });
                    }
                    if (form.requires !== undefined && form.requires.all !== undefined && form.requires.all.length) {
                        checkForSubforms(validator, service, form.requires.all, false);
                    }
                    if (form.requires !== undefined && form.requires.any !== undefined && form.requires.any.length) {
                        checkForSubforms(validator, service, form.requires.any, false);
                    }
                    if (form.optional !== undefined && form.optional !== undefined && form.optional.length) {
                        checkForSubforms(validator, service, form.optional, true);
                    }
                }

                if (parseInt(service) === constants.POST_SVC_INSTAGRAM_BUSINESS) {
                    if (postData.publishAsStory !== undefined && postData.publishAsStory) {
                        let count = this.getMediaCount('image');

                        count += this.getMediaCount('video');

                        if (count === 0) {
                            setError(service, 'publishAsStory', `${ConstantMixin.getPostServiceNameByCode(service)} stories must contain at least one photo or video.`);
                        }
                    }
                }

                if (parseInt(service) === constants.POST_SVC_FACEBOOK) {
                    let videoCount = this.getMediaCount('video'),
                        imageCount = this.getMediaCount('image');

                    if (postData.publishAsReel !== undefined && postData.publishAsReel) {
                        if (videoCount !== 1 || imageCount > 0) {
                            setError(service, 'publishAsReel', `${ConstantMixin.getPostServiceNameByCode(service)} Reels may contain a single video.`);
                        }
                    }
                    //          7/24/2025  Disable this because we are not allowing any FB mixed media currently because it caused breakage when conforming automated FB posts that might have mixed media (from an IG source)
//                    if ((videoCount >= 1 && imageCount >= 1) && !postData.publishAsStory) {
//                        setError(service, 'publishAsStory', `${ConstantMixin.getPostServiceNameByCode(service)} posts with mixed media must be published as a story.`);
//                    }
                }

                if (parseInt(service) === constants.POST_SVC_SNAPCHAT) {
                    let imageCount = this.getMediaCount('image');
                    if (imageCount >= 1 && postData.form === 'spotlight') {
                        setError(service, 'form', `Choose post type 'Story' to post an image to ${ConstantMixin.getPostServiceNameByCode(service)}`);
                    }
                }
            }

        });

        if (!_.isEqual(this.state.validationErrors, nextValidationErrors)) {
            this.setState({
                validationErrors: nextValidationErrors
            });
        }

        return isValid;
    }

    updateMediaErrors(nextErrors) {
        let nextMediaErrors = Utilities.deepClone(this.state.mediaErrors);

        Object.keys(nextErrors).map((service) => {
            if (nextMediaErrors[service] === undefined) {
                nextMediaErrors[service] = {};
            }
            if (nextErrors[service].validation !== undefined && nextErrors[service].validation === '') {
                delete nextMediaErrors[service]
            } else {
                nextMediaErrors[service] = nextErrors[service];
            }

        });

        this.setState({
            mediaErrors: nextMediaErrors
        });

    }

    clearMediaErrors(services) {
        let nextMediaErrors = Utilities.deepClone(this.state.mediaErrors);

        for (let i = 0; i < services.length; ++i) {
            if (nextMediaErrors[services[i]] !== undefined) {
                delete nextMediaErrors[services[i]];
            }
        }

        this.setState({
            mediaErrors: nextMediaErrors
        });

    }

    addLinkInfoToPostData(postData, serviceId) {
        let constants = this.props.app.config.constants,
            linkInfo = null,
            serviceData = null;

        if (this.linklessServices.indexOf(serviceId) !== -1) {
            serviceData = postData.services[serviceId];
            if (serviceData.link) {
                linkInfo = this.state.linkPreviews[serviceData.link];
                if (linkInfo) {
                    if (serviceId === constants.POST_SVC_TWITTER) {
                        if (linkInfo.twitter_preview !== undefined && linkInfo.twitter_preview === true && linkInfo.twitter_media !== undefined && linkInfo.twitter_media.length) {
                            postData.services[serviceId].imageLink = linkInfo.twitter_media[0].link;
                        } else if (linkInfo.media !== undefined && linkInfo.media.length) {
                            postData.services[serviceId].imageLink = linkInfo.media[0];
                        }
                    } else {
                        if (linkInfo.media !== undefined && linkInfo.media.length) {
                            postData.services[serviceId].imageLink = linkInfo.media[0];
                        }
                    }
                }
            }
        }

        if (this.populateTitleForServices.indexOf(serviceId) !== -1) {
            serviceData = postData.services[serviceId];
            if (serviceData.link) {
                linkInfo = this.state.linkPreviews[serviceData.link];
                if (linkInfo) {
                    serviceData.title = (linkInfo.title !== undefined) ? linkInfo.title : '';
                    // What's code without special cases and exceptions?!?
                    if ([constants.POST_SVC_SLACK, constants.POST_SVC_TUMBLR].indexOf(serviceId) !== -1) {
                        serviceData.body = (linkInfo.summary !== undefined) ? linkInfo.summary : '';
                    }
                }
            }
        }

    }

    switchView(nextView) {

		if (['providehandle', 'blueskycreds', 'createfeed'].indexOf(nextView) === -1) {
			nextView = '';
		}

		this.setState({
			socialHelperView: nextView
		});

	}

    // Googles recursive forms need to go up to the server
    // referenced by the form name.
    transformGoogleData(serviceData, how) {
        let constants = this.props.app.config.constants,
            validator = this.props.posts.postValidators[constants.POST_SVC_GMYBUSINESS],
            form = null,
            formKeys = [],
            formFields = [],
            transformedData = {
                form: serviceData.form
            };

        const transformer = (fields, object, source) => {
            fields.map((field) => {
                if (formKeys.indexOf(field) >= 0) {
                    let subForm = validator.forms[field],
                        subFields = [];

                    if (subForm) {
                        subFields = getFormFields(subForm);
                        if (how === 'object') {
                            object[field] = {};
                            transformer(subFields, object[field], source);
                            if (_.isEmpty(object[field])) {
                                delete object[field];
                            }
                        } else {
                            if (how === 'object') {
                                transformer(subFields, object, source[field]);
                            } else {
                                if (source[field] !== undefined) {
                                    transformer(subFields, object, source[field]);
                                }
                            }
                        }
                    }
                } else {
                    // be sure to copy in the hashes
                    if (field === 'mb_id' && source.hashes !== undefined) {
                        object.hashes = source.hashes;
                    }

                    if (source[field]) {
                        object[field] = source[field];
                        // some of the numeric values are getting cast to strings on the backend
                        // turn them back into numbers (specifically mb_id)
                        if (field === 'mb_id' && _.isString(source[field])) {
                            object[field] = parseInt(source[field], 10);
                        }

                    }
                }
            });

            return object;
        };

        // if no validator then we got bigger problems but safe to check anyhow
        if (validator) {
            form = validator.forms[serviceData.form];

            if (form) {
                formKeys = Object.keys(validator.forms);
                formFields = getFormFields(form);
                transformedData = transformer(formFields, transformedData, serviceData);
                // fields that aren't officially in the yaml need to be
                // copied back into the object when they're present
                if (serviceData.imageLink !== undefined && serviceData.imageLink !== '') {
                    transformedData.imageLink = serviceData.imageLink;
                }
                if (serviceData.id !== undefined) {
                    transformedData.id = serviceData.id;
                }
                if (serviceData.version !== undefined) {
                    transformedData.version = serviceData.version;
                }
            }

        }

        return transformedData;

    }

    addItemInfoDecorator(serviceData, serviceId) {
        let constants = this.props.app.config.constants,
            linkInfo = null,
            form = (this.props.posts.postValidators[serviceId] !== undefined && this.props.posts.postValidators[serviceId].forms !== undefined) ? this.props.posts.postValidators[serviceId].forms[serviceData.form] : null;

        if (form && form.preview_display === 1 &&
            serviceData.link !== undefined &&
            serviceData.link &&
            this.state.linkPreviews[serviceData.link] !== undefined) {
            linkInfo = this.state.linkPreviews[serviceData.link];

            serviceData.itemInfo = {
                title: linkInfo.title !== undefined ? linkInfo.title : '',
                summary: linkInfo.summary !== undefined ? linkInfo.summary : '',
                preview_display: 1
            };

            if (serviceId === constants.POST_SVC_TWITTER) {
                if (linkInfo.twitter_preview !== undefined && linkInfo.twitter_preview !== undefined && linkInfo.twitter_preview === true) {
                    if (linkInfo.twitter_media !== undefined && linkInfo.twitter_media.length) {
                        serviceData.itemInfo.imageLink = linkInfo.twitter_media[0].link;
                    } else {
                        if (linkInfo.media !== undefined && linkInfo.media.length) {
                            serviceData.itemInfo.imageLink = linkInfo.media[0];
                        }
                    }
                } else if (linkInfo.media !== undefined && linkInfo.media.length) {
                    serviceData.itemInfo.imageLink = linkInfo.media[0];
                }
            } else {
                if (linkInfo.media !== undefined && linkInfo.media.length) {
                    serviceData.itemInfo.imageLink = linkInfo.media[0];
                }
            }
        } else {
            // clear out the itemInfo if the user has removed the link
            if (serviceData.link === undefined || serviceData.link && serviceData.itemInfo !== undefined) {
                delete serviceData.itemInfo
            }
        }

    }

    // right now only tiktok supports video thumb selection on the backend,
    // don't show that modal unless the service allows it (this is assuming it supports multi images)
    hasVideoThumbSupport = (serviceId) => {
        if (serviceId) {
            if (this.props.posts.postValidators[serviceId].fields.cover_ms !== undefined) {
                return true;
            }
        } else {
            let selectedServices = Object.keys(this.state.selectedSocials);
            for (let i = 0; i < selectedServices.length; ++i) {
                if (this.props.posts.postValidators[selectedServices[i]].fields.cover_ms !== undefined) {
                    return true;
                }
            }
        }

        return false;
    }

    showMediaEditor(type, serviceId, hash, reset) {
        let accessoryServiceId = 0,
            accessoryHash = '';

        if (type.match("mediaUploader")) {
            this.pushAccessoryModal('mediaUploader', reset);
        } else if (type.match("fullEditor")) {
            this.pushAccessoryModal('fullEditor', reset);
        } else if (type.match("image")) {
            this.pushAccessoryModal('imageEditor', reset);
        } else if (type.match("video")) {
            this.pushAccessoryModal('fullEditor', reset);
        } else {
            this.pushAccessoryModal('galleryChooser', reset);
        }

        if (hash) {
            accessoryHash = hash;
        }

        if (serviceId) {
            accessoryServiceId = parseInt(serviceId);
        }

        if (accessoryServiceId || accessoryHash) {
            this.setState({
                accessoryServiceId,
                accessoryHash
            });
        }

    }

    supportsMediaEditing(mediaType, serviceId) {
        let fields = [],
            supportsEditing = false,
            i = 0,
            validator = null;

        const checkFields = (validator, fields) => {
            let fieldCheck = false;

            if (validator) {
                // be sure to scope i here so it doesn't grab the i
                // in the higher scope and cause problems
                for (let i = 0; i < fields.length; ++i) {
                    if (fields[i].match(/multi/)) {
                        let mediaCount = 0;
                        mediaCount += (validator.fields.mb_id !== undefined && validator.fields.mb_id.max_images) ? validator.fields.mb_id.max_images : 0;
                        mediaCount += (validator.fields.mb_id !== undefined && validator.fields.mb_id.max_videos) ? validator.fields.mb_id.max_videos : 0;
                        if (mediaCount >= 1) {
                            fieldCheck = true;
                        }
                    } else if (validator.fields[fields[i]] !== undefined) {
                        fieldCheck = true;
                        break;
                    }
                }
            }

            return fieldCheck;
        };

        if (mediaType) {
            if (mediaType.match("image")) {
                fields = ['alt_text'];
            } else if (mediaType.match("video")) {
                fields = ['cover_ms'];
            }
        }

        // add a sentinel to check out multi-media support
        fields.push('multi');

        // if no service id is passed in
        if (!serviceId) {
            if (this.state.postData.shared.hashes !== undefined && this.state.postData.shared.hashes.length > 1) {
                return true;
            }
            let serviceKeys = Object.keys(this.state.selectedSocials);
            for (i = 0; i < serviceKeys.length; ++i) {
                validator = this.props.posts.postValidators[serviceKeys[i]];
                supportsEditing = checkFields(validator, fields);
                if (supportsEditing) {
                    break;
                }
            }
        } else {
            if (this.state.postData.services[serviceId].hashes !== undefined && this.state.postData.services[serviceId].hashes.length > 1) {
                return true;
            }
            validator = this.props.posts.postValidators[serviceId];
            supportsEditing = checkFields(validator, fields);
        }

        return supportsEditing;
    }

    pushAccessoryModal(modal, resetStack) {
        let nextaccessoryModalStack = [...this.state.accessoryModalStack];

        if (resetStack) {
            nextaccessoryModalStack = [];
        }

        nextaccessoryModalStack.push(modal);

        this.setState({
            accessoryModalStack: nextaccessoryModalStack
        });
    }

    popAccessoryModal() {
        let nextaccessoryModalStack = [...this.state.accessoryModalStack];

        nextaccessoryModalStack.pop();

        this.setState({
            accessoryModalStack: nextaccessoryModalStack
        });
    }

    mediaHashHasErrors(hash, service) {
        let services = Object.keys(this.state.mediaErrors),
            mediaErrors = [];

        // only return errors when in network mode
        if (!service) {
            return mediaErrors;
        }

        if (services.length) {
            for (let i = 0; i < services.length; ++i) {
                if (this.state.mediaErrors[services[i]]) {
                    if (service && parseInt(services[i]) !== parseInt(service)) {
                        continue
                    }
                    if (this.state.mediaErrors[services[i]].validation !== undefined &&
                        this.state.mediaErrors[services[i]].validation[hash]) {
                        mediaErrors.push(this.state.mediaErrors[services[i]].validation[hash]);
                    }
                }
            }
        }

        return mediaErrors;
    }

    toggleHashtagSelector(e) {

        this.setState({
            isHashtagSelectorVisible: (this.state.isHashtagSelectorVisible) ? false : true
        });

    }

    hashtagSelectionCallback(tag, action, service) {
        let nextPostData = Utilities.deepClone(this.state.postData),
            data = null;

        // CONVERT!!
        service = parseInt(service);

        if (!service) {
            data = nextPostData.shared;
        } else {
            data = nextPostData.services[service];
        }

        if (data.message !== undefined) {
            if (action === 'add') {
                data.message += ` ${tag}`;
            } else {
                data.message = data.message.replace(" " + tag, '');
            }
        }

        this.setState({
            postData: nextPostData
        });

        return data.message;

    }

    showAIHelper(mode, serviceId) {

        this.setState({
            accessoryServiceId: (serviceId) ? serviceId : 0,
            aiMode: mode
        }, () => {
            this.pushAccessoryModal('aiHelper');
        });

    }

    setTikTokForm(postData, thumbs) {
        let constants = this.props.app.config.constants,
            hashes = postData.services[constants.POST_SVC_TIKTOK].hashes,
            hasImage = false,
            hasVideo = false,
            nextForm = postData.services[constants.POST_SVC_TIKTOK].form;

        for (let i = 0; i < hashes.length; ++i) {
            let media = thumbs.find((image) => { return image.hash === hashes[i]});
            if (media && media.type.match("image")) {
                hasImage = true;
            } else if (media && media.type.match("video")) {
                hasVideo = true;
            }
        }

        if (hasImage) {
            nextForm = "photo_post";
        } else if (!hasImage && hasVideo) {
            nextForm = "video_post";
        }
        // assign by reference
        postData.services[constants.POST_SVC_TIKTOK].form = nextForm;

    }

    storeVideoInfo(videoInfo) {
        let nextVideoInfo = [...this.state.videoInfo],
            videoIndex = nextVideoInfo.findIndex(({hash, serviceId}) => { return videoInfo.hash === hash && videoInfo.serviceId === serviceId; });

        if (videoIndex !== -1) {
            nextVideoInfo.splice(videoIndex, 1, videoInfo);
        } else {
            nextVideoInfo.push(videoInfo);
        }

        this.setState({
            videoInfo: nextVideoInfo
        });

    }

    removeVideoInfo(hash, serviceId) {
        let nextVideoInfo = [];

        for (let i = 0; i < this.state.videoInfo.length; ++i) {
            let video = this.state.videoInfo[i];
            if (video.hash !== hash && video.serviceId !== serviceId) {
                nextVideoInfo.push(video);
            }
        }

        this.setState({
            videoInfo: nextVideoInfo
        });

    }

    render() {
        let sortMenu = null,
            noActiveSocials = null,
            socialList = null,
            socialCount = null,
            selectLabel = null,
            accessoryModal = null,
            mediaControl = null,
            sharedLink = null,
            linkPreview = null,
            mediaSourceOptions = [];

        const hasTag = () => {

            let serviceTag = false;
            Object.keys(this.state.postData.services).map((service) => {
                if (this.state.postData.services[service].tagID !== undefined &&
                    this.state.postData.services[service].tagID !== 0) {
                        serviceTag = true;
                }
            });

            if (serviceTag || (this.state.postData.shared.tagID !== undefined && this.state.postData.shared.tagID !== 0)) {
                return true;
            }

            return false;
        }

        mediaSourceOptions = [
            {
                key: 'upload',
                icon: 'fa fa-upload',
                label: 'Upload Files',
                action: () => {
                    this.pushAccessoryModal('mediaUploader');
                }
            },
            {
                key: 'unsplash',
                icon: 'ds-icon icon-unsplash',
                label: 'Unsplash',
                action: () => {
                   this.showMediaEditor('galleryChooser', 0);
                }
            },
            {
                key: 'gdrive',
                icon: 'ds-icon icon-google-drive',
                label: 'Google Drive',
                action: () => {
                    this.pushAccessoryModal('gdrive');
                }
            },
            {
                key: 'gphotos',
                icon: 'ds-icon icon-google-photos',
                label: 'Google Photos',
                action: () => {
                    this.pushAccessoryModal('gphotos');
                }
            },
            {
                key: 'dropbox',
                icon: 'fa fa-dropbox',
                label: 'Dropbox',
                action: () => {
                    this.pushAccessoryModal('dropbox');
                }
            },
            {
                key: 'onedrive',
                icon: 'ds-icon icon-onedrive',
                label: 'OneDrive',
                action: () => {
                    this.pushAccessoryModal('onedrive');
                }
            },
        ];

        if (this.state.isLoading || this.props.app.firstLoad.SOCIAL_LIST === false) {
            return (
                <Loading/>
            );
        }

        if (this.state.accessoryModalStack.length) {
            let accessoryContent = null,
                cancelAction = () => {
                    this.popAccessoryModal();
                    if (this.state.accessoryModalStack.length === 1) {
                        this.setState({
                            accessoryServiceId: 0,
                            accessoryHash: ''
                        });
                    }
                };

            switch (this.state.accessoryModalStack[this.state.accessoryModalStack.length - 1]) {
                case 'groups':
                    accessoryContent = (
                        <PostingGroups
                            {...this.props}
                            cancelAction={cancelAction}
                            confirmAction={(socialIds) => {
                                let nextSelectedSocials = Utilities.deepClone(this.state.selectedSocials);

                                // make sure the list of ids are ints
                                socialIds.map((id, i) => {
                                    socialIds[i] = parseInt(id);
                                })

                                socialIds.map((socialId) => {
                                    // make sure the id is in the active list
                                    let social = this.props.socials.list.find(({id}) => { return id === socialId; });
                                    if (social) {
                                        if (nextSelectedSocials[social.psID] === undefined) {
                                            nextSelectedSocials[social.psID] = [];
                                        }
                                        if (nextSelectedSocials[social.psID].indexOf(socialId) === -1) {
                                            nextSelectedSocials[social.psID].push(socialId);
                                        }
                                    }
                                });

                                this.popAccessoryModal();

                                this.setState({
                                    selectedSocials: nextSelectedSocials
                                });

                            }}/>
                    )
                    break;

                case 'category':
                    accessoryContent = (
                        <CategoryChooser
                            {...this.props}
                            serviceType={this.state.accessoryServiceId}
                            postData={this.state.postData}
                            cancelAction={cancelAction}
                            confirmAction={(category) => {
                                this.addCategory(category);
                            }}/>
                    );
                    break;

                case 'scheduler':
                    accessoryContent = (
                        <PostScheduler
                            {...this.props}
                            postData={this.state.postData}
                            editMode={this.state.editMode}
                            selectedSocials={this.state.selectedSocials}
                            cancelAction={cancelAction}
                            confirmAction={(timestamps) => {
                                let nextPostData = Utilities.deepClone(this.state.postData);

                                nextPostData.params.post_times = timestamps;

                                this.popAccessoryModal();

                                this.setState({
                                    postData: nextPostData,
                                    isWorking: true
                                }, () => {
                                    this.makePost();
                                });

                            }}/>
                    );
                    break;

                case 'everqueue':
                    accessoryContent = (
                        <EverqueueControls
                            {...this.props}
                            postData={this.state.postData}
                            cancelAction={cancelAction}
                            confirmAction={(postNow, endTimestamp) => {
                                let nextPostData = Utilities.deepClone(this.state.postData),
                                    constants = this.props.app.config.constants;

                                if (endTimestamp) {
                                    nextPostData.params.killTs = endTimestamp;
                                }

                                if (postNow) {
                                    nextPostData.params.postFlag = constants.POST_NOW;
                                    nextPostData.params.everqFlag = 1;
                                }

                                this.popAccessoryModal();

                                this.setState({
                                    postData: nextPostData,
                                    isWorking: true
                                }, () => {
                                    this.makePost();
                                });

                            }}/>
                    );
                    break;

                case 'imageEditor':
                    accessoryContent = (
                        <ImageEditorModal
                            {...this.props}
                            postData={this.state.postData}
                            mediaThumbs={this.state.mediaThumbs}
                            removeThumb={this.removeThumb}
                            cancelAction={cancelAction}
                            selectedServices={Object.keys(this.state.selectedSocials)}
                            accessoryServiceId={this.state.accessoryServiceId}
                            accessoryHash={this.state.accessoryHash}
                            showMediaEditor={this.showMediaEditor}
                            mediaHashHasErrors={this.mediaHashHasErrors}
                            confirmAction={(data) => {
                                let nextPostData = Utilities.deepClone(this.state.postData),
                                    service = nextPostData.shared;

                                if (data.accessoryServiceId) {
                                    service = nextPostData.services[data.accessoryServiceId];
                                }

                                service.hashes = data.hashes;

                                if (Object.keys(data.alt_text).length) {
                                    service.alt_text = data.alt_text;
                                }

                                this.popAccessoryModal();

                                this.setState({
                                    postData: nextPostData,
                                    accessoryServiceId: 0,
                                    accessoryHash: ''
                                });

                            }}/>
                    )
                    break;

                case 'galleryChooser':
                    accessoryContent = (
                        <GalleryChooser
                            {...this.props}
                            cancelAction={cancelAction}
                            accessoryServiceId={this.state.accessoryServiceId}
                            attachMedia={this.attachMedia}
                            removeThumb={this.removeThumb}
                            postData={this.state.postData.shared}
                            selectedServices={(Object.keys(this.state.selectedSocials))}
                            updateMediaErrors={this.updateMediaErrors}
                            clearMediaErrors={this.clearMediaErrors}/>
                    );
                    break;

                case 'mediaUploader':
                    accessoryContent = (
                        <PostToolUploader
                            isModal={true}
                            {...this.props}
                            cancelAction={cancelAction}
                            attachMedia={this.attachMedia}
                            postData={this.state.postData}
                            accessoryServiceId={this.state.accessoryServiceId}
                            selectedServices={(Object.keys(this.state.selectedSocials))}
                            updateMediaErrors={this.updateMediaErrors}
                            clearMediaErrors={this.clearMediaErrors}
                            showMediaEditor={this.showMediaEditor}
                            supportsMediaEditing={this.supportsMediaEditing}/>
                    );
                    break;

                case 'aiHelper':
                    accessoryContent = (
                        <AIHelper
                            {...this.props}
                            postData={this.state.postData}
                            cancelAction={cancelAction}
                            requestChange={FormUtilityMixin.requestChange.bind(this)}
                            accessoryServiceId={this.state.accessoryServiceId}
                            mode={this.state.aiMode}
                            updateMessage={(nextMessageData) => {
                                let nextPostData = Utilities.deepClone(this.state.postData),
                                    service = nextPostData.shared;

                                if (this.state.accessoryServiceId) {
                                    service = nextPostData.services[this.state.accessoryServiceId];
                                }
                                service.message = nextMessageData.message;

                                this.popAccessoryModal();

                                this.setState({
                                    postData: nextPostData,
                                    accessoryServiceId: 0,
                                    accessoryHash: '',
                                    aiMode: ''
                                });

                                if (this.props.recordEvent) {
                                    this.props.recordEvent({
                                        pub_id: this.props.user.detail.id,
                                        event_name: 'Updated Text with AI Helper',
                                        event_data: {
                                            uuid: nextMessageData.uuid
                                        }
                                    });
                                }

                            }}/>
                    );
                    break;

                case 'fullEditor':
                    accessoryContent = (
                        <MediaEditor
                            {...this.props}
                            postData={this.state.postData}
                            cancelAction={cancelAction}
                            attachMedia={this.attachMedia}
                            removeThumb={this.removeThumb}
                            accessoryServiceId={this.state.accessoryServiceId}
                            accessoryHash={this.state.accessoryHash}
                            mediaThumbs={this.state.mediaThumbs}
                            videoInfo={this.state.videoInfo}
                            storeVideoInfo={this.storeVideoInfo}
                            removeVideoInfo={this.removeVideoInfo}
                            hasVideoThumbSupport={this.hasVideoThumbSupport}/>
                    );
                    break;

                case 'gdrive':
                case 'gphotos':
                case 'dropbox':
                case 'onedrive':
                    accessoryContent = (
                        <UploadcareModal
                            {...this.props}
                            sourceList={this.state.accessoryModalStack[this.state.accessoryModalStack.length - 1]}
                            cancelAction={cancelAction}
                            attachMedia={this.attachMedia}
                            updateMediaErrors={this.updateMediaErrors}
                            clearMediaErrors={this.clearMediaErrors}/>
                    );
                    break;

                default:
                    break;
            }

            if (accessoryContent) {
                accessoryModal = (
                    <MinimalModal
                        mode={this.state.accessoryModalStack[this.state.accessoryModalStack.length - 1]}
                        cancelAction={cancelAction}
                        content={accessoryContent}/>
                );
            }

         }

         /*
         <li data-action="toggleSocialLabels">{this.state.userPrefs.showLabels ? 'Hide' : 'Show'} Social Names</li>
         */

        if (this.state.showSortMenu && ['edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) === -1) {
            sortMenu = (
                <div className="pt-sort-menu" ref={this.sortMenuRef}>
                    <ul className="sort-options" onClick={this.sortMenuHandler}>
                        <li data-action="sort" data-dir="ASC">Sort A - Z</li>
                        <li data-action="sort" data-dir="DESC">Sort Z - A</li>
                        <li data-action="sort" data-dir="type">Sort by Type</li>
                        <li data-action="chooseGroup">Choose Posting Group</li>
                    </ul>
                </div>
            );
        }

        if (this.props.socials.list.length == 0) {
            switch (this.state.socialHelperView) {
                case 'blueskycreds':
                    noActiveSocials = (
						<div>
							<BlueskyCreds
								{...this.props}
								switchView={this.switchView}/>
						</div>
					);
                    break;

                case 'createfeed':
                    noActiveSocials = (
						<div>
							<CreateFeedOutputPanel
								{...this.props}
								switchView={this.switchView}/>
						</div>
					);
                    break;

				case 'providehandle':
					noActiveSocials = (
						<div>
							<MastodonHandle
								{...this.props}
								switchView={this.switchView}/>
						</div>
					);
                    break;

				default:
                    noActiveSocials = (
                        <div className="no-active-socials">
                            <div className="social-list-header">
                                <div className="social-list-herald">Select social accounts</div>
                            </div>
                            <div className="tw-root">
                                <TypeSelection
                                    {...this.props}
                                    types={this.props.socials.types}
                                    context='posting-tool'
                                    extraClasses={'pt-type-selector'}
                                    switchView={this.switchView}
                                    tile={true}/>
                            </div>
                        </div>
                    );
					break;
			}

        } else {
            socialList = (
                <ul className="social-list">
                    {this.props.socials.list.map((social) => {
                        let isActive = false,
                            isSelectable = true,
                            constants = this.props.app.config.constants;

                        if (this.state.selectedSocials[social.psID] !== undefined) {
                            if (this.state.selectedSocials[social.psID].indexOf(social.id) !== -1) {
                                isActive = true;
                            }
                            if (social.psID === constants.POST_SVC_YOUTUBE) {
                                if (_.isArray(this.state.selectedSocials[social.psID]) &&
                                    this.state.selectedSocials[social.psID].indexOf(social.id) === -1) {
                                    isSelectable = false;
                                }
                            }
                        }

                        return (
                            <li key={social.id}>
                                <PostSocialButton
                                    {...this.props}
                                    social={social}
                                    isActive={isActive}
                                    isSelectable={isSelectable}
                                    onClick={this.onSocialClick}/>
                            </li>
                        );
                    })}
                    <li>
                        <PostSocialButton
                            {...this.props}
                            connect={true}
                            onClick={this.onSocialClick}/>
                    </li>
                </ul>
            );
        }

        if (['edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) === -1) {
            if (this.getSelectedSocialCount()) {
                if (this.getSelectedSocialCount() === 1) {
                    socialCount = "(1) social";
                } else {
                    socialCount = `(${this.getSelectedSocialCount()}) socials`;
                }
            } else {
                socialCount = "(0) socials";
            }

            if (this.getSelectedSocialCount() === this.props.socials.list.filter((social) => social.activeFlag === 1).length) {
                selectLabel = "select none";
            } else {
                selectLabel = "select active";
            }
        }

        if (this.state.postData.shared.mb_id || (this.state.postData.shared.hashes !== undefined && this.state.postData.shared.hashes.length)) {
            let hashes = (this.state.postData.shared.hashes !== undefined) ? this.state.postData.shared.hashes : [];
            mediaControl = (
                <div className="pt-media-block shared">
                    <ThumbnailPreview
                        {...this.props}
                        mediaThumbs={this.state.mediaThumbs}
                        mb_id={this.state.postData.shared.mb_id}
                        hashes={hashes}
                        editMode='shared'
                        showMediaEditor={this.showMediaEditor}
                        mediaHashHasErrors={this.mediaHashHasErrors}
                        clearMediaErrors={this.clearMediaErrors}
                        supportsMediaEditing={this.supportsMediaEditing}
                        removeThumb={this.removeThumb}
                        requestChange={FormUtilityMixin.requestChange.bind(this)}/>
                </div>
            );

        }

        let categoryButtonClass = "tt-button tag-button",
            categoryName = '';
        if (this.state.postData.shared.tagID !== undefined && this.state.postData.shared.tagID !== 0) {
            categoryButtonClass += " active";
            if (this.state.postData.shared.tagName !== undefined) {
                categoryName = this.state.postData.shared.tagName;
            }
        }

        if (this.state.editMode === 'shared' &&
            this.state.postData.shared.link !== '' &&
            !this.state.postData.shared.mb_id &&
             this.state.postData.shared.hashes.length === 0) {
            if (this.state.isLinkLoading) {
                linkPreview = (
                    <LinkPreview
                        {...this.props}
                        loading={true}
                        context="shared"/>
                );
            } else {
                linkPreview = (
                    <LinkPreview
                        {...this.props}
                        loading={false}
                        previewData={this.state.linkPreviews[this.state.postData.shared.link]}
                        context="shared"
                        removeLink={this.removeLink}/>
                );
            }
        }

        /*
         * X earns the same nudge Instagram gets: a link in a shared post is handled per-network
         * — no preview, and a QR code to opt into — and none of that is visible until the panels
         * are open. Deliberately not raised through validateServices(), because setError() also
         * clears isValid and would block a post that has nothing wrong with it.
         */
        let twitterSvc = this.props.app.config.constants.POST_SVC_TWITTER,
            twitterHasLink = !!(this.state.postData.shared.link &&
                this.state.selectedSocials[twitterSvc] !== undefined &&
                this.state.selectedSocials[twitterSvc].length);

        let errorNotice = null;
        if (((Object.keys(this.state.validationErrors).length || Object.keys(this.state.mediaErrors).length) && this.state.isDirty) ||
            twitterHasLink) {
            errorNotice = (
                <div className="validation-notice">
                    <i className="icon ion-android-alert"></i>
                </div>
            );
        }

        let postErrorDisplay = null;
        if (this.state.postErrors.length) {
            postErrorDisplay = (
                <ul className="pt-post-errors">
                    {this.state.postErrors.map((error, i) => {
                        return (
                            <li key={`post-error-${i}`} className="post-error">
                                <i className="icon ion-android-alert"></i>{error}
                            </li>
                        );
                    })}
                </ul>
            );
        }

        let postActions = [
            {
                action: 'share',
                icon: <i className='fa fa-share'/>,
                label: 'Post Now',
                callback: () => {
                    this.postActionHandler('share');
                },
                immediate: true
            },
            {
                action: 'schedule',
                icon: <i className='fa fa-calendar-o'/>,
                label: 'Schedule',
                callback: () => {
                    this.postActionHandler('schedule');
                },
                immediate: true
            },
            {
                action: 'sharenext',
                icon: <i className='fa fa-step-forward'/>,
                label: 'Share Next',
                callback: () => {
                    this.postActionHandler('next');
                },
                immediate: true
            },
            {
                action: 'queue',
                icon: <i className='fa fa-list-ul'/>,
                label: 'Add to Queue',
                callback: () => {
                    this.postActionHandler('queue');
                },
                immediate: true
            },
            {
                action: 'everqueue',
                icon: <i className='ds-icon icon-everqueue'/>,
                label: 'Add to Everqueue',
                callback: () => {
                    this.postActionHandler('everqueue');
                },
                immediate: true
            },
        ];
        if (hasTag()) {
            postActions = [
                {
                    action: 'queue',
                    icon: <i className='fa fa-list-ul'/>,
                    label: 'Add to Queue',
                    callback: () => {
                        this.postActionHandler('queue');
                    },
                    immediate: true
                },
                {
                    action: 'everqueue',
                    icon: <i className='ds-icon icon-everqueue'/>,
                    label: 'Add to Everqueue',
                    callback: () => {
                        this.postActionHandler('everqueue');
                    },
                    immediate: true
                },
            ];
        }

        if (['edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) !== -1) {
            postActions = [
                {
                    action: 'save',
                    icon: <i className='fa fa-share'/>,
                    label: 'Save',
                    callback: () => {
                        this.postActionHandler('save');
                    },
                    immediate: true
                },
                {
                    action: 'schedule',
                    icon: <i className='fa fa-calendar-o'/>,
                    label: 'Edit Schedule',
                    callback: () => {
                        this.postActionHandler('schedule');
                    },
                    immediate: true
                },

            ];

            if (this.state.editMode === 'edit-queue') {
                postActions.push({
                    action: 'sharequeue',
                    icon: <i className='fa fa-share'/>,
                    label: 'Share Now',
                    callback: () => {
                        this.postActionHandler('sharequeue');
                    },
                    immediate: true
                });
            } else if (this.state.editMode === "edit-everqueue") {
                postActions.push({
                    action: 'shareeverqueue',
                    icon: <i className='fa fa-share'/>,
                    label: 'Share Now',
                    callback: () => {
                        this.postActionHandler('shareeverqueue');
                    },
                    immediate: true
                });
            }

        }

        let headerCopy = 'Compose Post';
        if (this.state.editMode === 'edit-queue') {
            headerCopy = 'Edit post';
        } else if (this.state.editMode === 'edit-everqueue') {
            headerCopy = 'Edit Everqueue post';
        } else if (noActiveSocials) {
            //headerCopy = 'Connect your social media profiles';
        }

        let noSelectedSocialWarning = null;
        if (this.state.isSocialWarningVisible) {
            noSelectedSocialWarning = (
                <ul className="pt-post-errors">
                    <li className="post-error">
                        <i className="icon ion-android-alert"></i> Please choose at least one social to continue.
                    </li>
                </ul>
            );
        }

        let hashtagButtonClass = 'tt-button hashtags',
            hashtagSelector = null;
        if (this.state.isHashtagSelectorVisible) {
            hashtagButtonClass += ' active';
            hashtagSelector = (
                <HashtagGenerator
                    {...this.props}
                    postData={this.state.postData.shared}
                    onHashtagSelect={this.hashtagSelectionCallback}
                    service={0}/>
            );
        }

        let aiHelperButton = null;
        if (typeof this.state.postData.shared.message === "string" && this.state.postData.shared.message.trim() !== '') {
            aiHelperButton = (
                <div className={"tt-button ai-helper"} role="button" aira-label="Edit content with AI" onClick={() => {
                    this.showAIHelper('prompted');
                }}>
                    <i className="icon ion-ios-color-wand"/> <div className="new-tag">Edit with AI</div>
                </div>
            );
        }

        return (
            <div className="posting-tool">
                {accessoryModal}
                <div className="pt-header">
                    {headerCopy}
                </div>
                {postErrorDisplay}
                {['edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) === -1 ? (
                    <div className="pt-social-container">
                        {(noActiveSocials) ? (
                            noActiveSocials
                        ) : (
                            <div>
                                <div className="social-list-header">
                                    <div className="social-list-herald">Select social accounts</div>
                                    <div className={"sort-button" + ((this.state.showSortMenu) ? ' active' : '')} onClick={this.showSortMenu}>
                                        <i className="icon ion-android-funnel"></i>
                                    </div>
                                    {sortMenu}
                                </div>
                                {noSelectedSocialWarning}
                                <div className='social-list-container'>
                                    {socialList}
                                </div>
                                <div className="social-status">
                                    <div className="social-count">
                                        {socialCount}
                                    </div>
                                    <div className="select-control" role="button" aria-label={selectLabel} onClick={this.selectAllHandler}>
                                        {selectLabel}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ) : null}
                {(this.state.editMode === 'shared') ? (
                    <div>
                        <div className="pt-shared-content">
                            <div className="media-content">
                                {mediaControl}
                            </div>
                            <div className="text-content">
                                <div className="ai-helper-guide-button" role="button" aria-label="Generate posts with AI" onClick={() => {
                                    this.showAIHelper('guided');
                                }}>
                                    AI Helper ✨
                                </div>
                                <textarea
                                    ref={this.sharedMessageRef}
                                    value={this.state.postData.shared.message}
                                    placeholder={"What would you like to share?"}
                                    onChange={FormUtilityMixin.requestChange.bind(this)}
                                    data-field="postData.shared.message"
                                    onPaste={TextareaEvents.onTextareaPaste.bind(this)}
                                    onKeyUp={TextareaEvents.onTextareaKeyUp.bind(this)}>
                                </textarea>
                                <div className="text-tools">
                                    <div className="tt-button media-source-chooser">
                                        <MediaSourceMenu
                                            {...this.props}
                                            mediaSourceOptions={mediaSourceOptions}/>
                                    </div>
                                    <div className="tt-button text-count">
                                        {this.getCharCount(this.state.postData.shared.message)}
                                    </div>
                                    <div className="tt-button emoji-button" role="button" aria-label="Add emoji to message" onClick={this.toggleEmojiPicker}>
                                        <i className="fa fa-smile-o"></i>
                                        {(this.state.isEmojiPickerVisible) ? (
                                            <div className="pt-picker-wrapper" ref={this.emojiPickerRef}>
                                                <Picker
                                                    onEmojiClick={(e, emoji) => {
                                                        if (this.sharedMessageRef.current) {
                                                            let postData = this.state.postData;

                                                            postData.shared.message = this.addEmoji(this.sharedMessageRef, emoji);

                                                            this.setState({
                                                                postData
                                                            });
                                                        }
                                                    }}
                                                    native={true}/>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className={categoryButtonClass} role="button" title={categoryName} aria-label="Choose Category" onClick={this.showCategoryPicker}>
                                        <i className="icon ion-ios-pricetag"></i>
                                    </div>
                                    <div className={hashtagButtonClass} role="button" aira-label="Add generated hashtags to message" onClick={this.toggleHashtagSelector}>
                                        <i className="icon ion-pound"/>
                                    </div>
                                    {aiHelperButton}
                                </div>
                            </div>
                        </div>
                        {hashtagSelector}
                        {linkPreview}
                    </div>
                ) : null}
                {(this.state.editMode === 'shared' && this.getSelectedSocialCount() > 0) ? (
                    <div className="pt-network-content borderless">
                        <div className="pt-edit-toggle" role="button" aria-label="Customize networks" onClick={this.changeEditMode}>
                            Customize for each platform {errorNotice}<i className="icon ion-chevron-down"></i>
                        </div>
                    </div>
                ) : null}
                {(['network', 'edit-queue', 'edit-everqueue'].indexOf(this.state.editMode) !== -1) ? (
                    <div>
                        {Object.keys(this.state.selectedSocials).map((key) => {
                            return (
                                <div className="pt-network-content" key={`service-${key}`}>
                                    <ServiceFields
                                        {...this.props}
                                        serviceType={key}
                                        editMode={this.state.editMode}
                                        serviceInfo={this.props.posts.postValidators[key]}
                                        postData={this.state.postData.services[key]}
                                        requestChange={FormUtilityMixin.requestChange.bind(this)}
                                        addEmoji={this.addEmoji}
                                        showCategoryPicker={this.showCategoryPicker}
                                        attachMedia={this.attachMedia}
                                        mediaThumbs={this.state.mediaThumbs}
                                        getCharCount={this.getCharCount}
                                        linkPreviews={this.state.linkPreviews}
                                        removeLink={this.removeLink}
                                        selectedSocials={this.state.selectedSocials}
                                        updateMediaErrors={this.updateMediaErrors}
                                        clearMediaErrors={this.clearMediaErrors}
                                        validationErrors={this.state.validationErrors}
                                        mediaErrors={this.state.mediaErrors}
                                        apiErrors={this.state.apiErrors}
                                        getUrlPreview={this.getUrlPreview}
                                        linklessServices={this.linklessServices}
                                        convertDateToObject={convertDateToObject}
                                        convertObjectToDate={convertObjectToDate}
                                        removeThumb={this.removeThumb}
                                        isLinkLoading={this.state.isLinkLoading}
                                        showMediaEditor={this.showMediaEditor}
                                        supportsMediaEditing={this.supportsMediaEditing}
                                        mediaSourceOptions={mediaSourceOptions}
                                        mediaHashHasErrors={this.mediaHashHasErrors}
                                        onHashtagSelect={this.hashtagSelectionCallback}
                                        showAIHelper={this.showAIHelper}/>
                                </div>
                            );
                        })}
                    </div>
                ) : null}
                {(this.props.socials.list.length > 0) ? (
                    <div className="pt-actions">
                        {this.state.whichEscapeHatch !== '' ? (
                            <div className="pt-escape-hatch">
                                <a href="#" onClick={() => {
                                        this.props.router.navigate(-1);
                                    }}>
                                    {"<"} {this.state.whichEscapeHatch}
                                </a>
                            </div>
                        ) : null}
                        <div className="button-push"></div>
                        {this.state.isWorking || this.state.isLinkLoading ? (
                            <div className="combo-button">
                                <div className="working">
                                    <i className="fa fa-circle-o-notch fa-spin"></i>
                                </div>
                            </div>
                        ) : (
                            <ComboButton
                                actions={postActions}
                                buttonClass={"pt-action-button"}
                                selectedAction={this.state.postAction}/>
                        )}

                    </div>
                ) : null}
                </div>
        );
    }
}

PostingTool.displayName = "PostingTool";

/*
 * SocialRestoreModule last, so it wraps PostingTool most closely and sits inside
 * ComponentWithContext — the plan check it runs needs the showUpgradeModal that
 * arrives with the outlet context.
 */
const enhance = compose(
    PostProvider,
    CategoryProvider,
    UtilityProvider,
    EverqueueProvider,
    QueueProvider,
    ComponentWithContext,
    SocialRestoreModule
)

export default enhance(PostingTool);
